// USA
export const locale = {
  lang: 'en',
  data: {
    PAYMENT: {
      METHOD_NUMBER: 'Method Number',
      PAYMENT_TYPE: 'Payment Type',
      EMPTY: 'No Methods available',
      DELETE_METHOD: {
        TITLE: 'Payment Deactivate',
        DESCRIPTION: 'Are you sure you want to permanently deactivate this payment method?',
        WAIT_DESCRIPTION: 'Payment method is deactivate...',
        MESSAGE: 'Payment method has been deactivate',
      },
    },
    CONTACT_AUDIT: { ACTIONS: 'History Logs' },
    CALENDAR: { CALENDAR: 'Calendar' },
    GLOBAL: {
      ENTITY: 'Entity',
      ENTITY_TYPE: 'Entity Type',
      BY_ENTITY_TYPE: 'By Entity Type',
      EDIT: 'Edit',
      SAVE: 'Save',
      SAVING: 'Saving...',
      SUBMIT: 'Submit',
      SUBMITTING: 'Submitting...',
      CONFIRM: 'Confirm',
      RESET: 'Reset',
      BACK: 'Back',
      CANCEL: 'Cancel',
      UNDO: 'Undo',
      KEEP: 'Keep',
      OVERRIDE: 'Override',
      CLOSE: 'Close',
      LINK_ENTITY: 'Link Entity',
      ALL: 'All',
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
      REVIEWED: 'Reviewed',
      NOT_REVIEWED: 'Not Reviewed',
      SHARE: 'Share',
      SEND: 'Send',
      DOWNLOAD: 'Download',
      DOWNLOAD_REASON: 'Download Reason',
      REQUIRED: 'Required',
      NOT_REQUIRED: 'Not Required',
      PRIMARY: 'Primary',
      NOT_PRIMARY: 'Not Primary',
      VISIBLE_EXPIRY: 'Visible/Expiry After',
      FILTER: 'Filter ',
      FILTER_BY: 'Filter by ',
      STATUS: 'Status',
      BY_STATUS: 'Status',
      SEARCH: 'Search ',
      IN_ALL_FIELDS: 'In All Fields',
      NO_RECORDS_FOUND: 'No Records Found',
      PLEASE_WAIT: 'Please Wait...',
      UPDATE_STATUS: 'Update Status',
      DELETE_ALL: 'Delete All',
      UNSPECIFIED_ERROR: 'Something Went Wrong. Please Try Again',
      SELECTED_RECORDS_COUNT: 'Selected records count: ',
      FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
      FETCH_SELECTED: 'Fetch Selected',
      NOT_ASSIGNED: 'Not assigned',
      VISIBLE: 'Visible',
      INVISIBLE: 'Invisible',
      CREATE: 'Create',
      NEXTSTEP: 'Next Step',
      PREVIOUS: 'Previous',
      PREVIEW: 'Preview',
      INFORMATION: 'Information',
      FORM_FIELD_REQUIRED: 'Form field is required',
      CONFLICT_CELL_PHONE: 'Cell phone is exist',
      UNASSIGNED: 'Unassigned',
      ASSIGNED: 'Assigned',
      BY_ASSIGNED: 'Assigned',
    },
    CHAT: {
      CHAT: 'Chat',
    },
    AGREEMENT: {
      EDIT_AGREEMENT: 'Edit',
      NEW_AGREEMENT: 'Create',
      STATUS: {
        SENT: 'Sent',
        COMPLETED: 'Completed',
        REVOKED: 'Revoked',
        EXPIRED: 'Expired',
        DECLINED: 'Declined',
        SIGNED: 'Signed',
        REMINDED: 'Reminded',
      },
      AGREEMENT_LIST: 'Agreement List',
      AGREEMENT_TEMPLATE_LIST: 'Agreement Template List',
      EDIT: {
        UPDATE_MESSAGE: 'Agreement has been updated',
        ADD_MESSAGE: 'Agreement has been created',
      },
      DELETE_AGREEMENT_SIMPLE: {
        TITLE: 'Agreement Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this agreement?',
        WAIT_DESCRIPTION: 'Agreement is deleting...',
        MESSAGE: 'Agreement has been deleted',
      },
      DELETE_AGREEMENT_MULTI: {
        TITLE: 'Agreements Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete the selected agreements?',
        WAIT_DESCRIPTION: 'Agreements are deleting...',
        MESSAGE: 'Selected agreements have been deleted',
      },
      REMIND_AGREEMENT: {
        TOOLTIP: 'Remind Agreement',
        TITLE: 'Agreements Remind',
        DESCRIPTION:
          'Are you sure you want to send a reminder to the signers of the selected agreement?',
        WAIT_DESCRIPTION: 'Sending Reminder...',
        MESSAGE: 'Reminder sent for agreement.',
      },
      REVOKE_AGREEMENT: {
        TITLE: 'Agreements Revoke',
        DESCRIPTION: 'Are you sure you want to revoke the selected agreement?',
        WAIT_DESCRIPTION: 'Revoking agreement...',
        MESSAGE: 'Agreement revoked.',
      },
      TABLE: {
        TITLE: 'Title',
        ID: 'ID',
        STATUS: 'Status',
        TYPE: 'Type',
        DATE_SENT: 'Date Sent',
        VOID_DATE: 'Revoke Date',
        VOID_REASON: 'Revoke Reason',
        COMPANY: 'Company',
      },
    },
    AGREEMENT_TEMPLATE: {
      EDIT_TEMPLATE: 'Edit',
      NEW_TEMPLATE: 'Create',
      EDIT: {
        UPDATE_MESSAGE: 'Agreement Template has been updated',
        ADD_MESSAGE: 'Agreement Template has been created',
      },
      DELETE_AGREEMENT_TEMPLATE_SIMPLE: {
        TITLE: 'Agreement Template Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this template?',
        WAIT_DESCRIPTION: 'Agreement Template is deleting...',
        MESSAGE: 'Agreement Template has been deleted',
      },
      DELETE_AGREEMENT_TEMPLATE_MULTI: {
        TITLE: 'Agreement Template Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete the selected template?',
        WAIT_DESCRIPTION: 'Agreement Templates are deleting...',
        MESSAGE: 'Selected template have been deleted',
      },
      ACTIVATE_AGREEMENT_TEMPLATE: {
        TITLE: 'Agreement Template Activate',
        DESCRIPTION: 'Are you sure you want to activate this template?',
        WAIT_DESCRIPTION: 'Agreement Template is activating...',
        MESSAGE: 'Agreement Template has been activated',
      },
      TABLE: {
        ID: 'ID',
        NAME: 'Name',
        TYPE: 'Type',
        OFFICE: 'Office',
        STATUS: 'Status',
        CREATED: 'Date Created',
      },
    },
    ROLES: {
      ROLES: 'Roles',
      ROLES_LIST: 'Role List',
      NEW_ROLE: 'Create',
      EDIT_ROLE: 'Edit',
      TITLE_REQUIRED: 'Role Title is Required',
      DUPLICATE_ENTRY: 'Duplicate Role',
      UPDATED: 'Role has been Updated',
      DELETED: 'Role has been deleted',
      RETRIEVED: 'Roles have been Retrieved',
      DELETE_ROLE_SIMPLE: {
        TITLE: 'Role Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this role?',
        WAIT_DESCRIPTION: 'Role is deleting...',
        MESSAGE: 'Role has been deleted',
      },
      DELETE_ROLE_MULTI: {
        TITLE: 'Roles Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete the selected roles?',
        WAIT_DESCRIPTION: 'Roles are deleting...',
        MESSAGE: 'Selected roles have been deleted',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Role has been updated',
        ADD_MESSAGE: 'Role has been created',
      },
      TABLE: {
        TITLE: 'Title',
        COMPANY: 'Company',
        TEMPLATE: 'Template',
      },
      FORM: {
        TITLE: 'Title',
        COMPANY: 'Company',
        DT_CREATED: 'Date and Time Created',
        DT_UPDATED: 'Date and Time Updated',
        TITLE_REQUIRED: 'Title is required',
        COMPANY_REQUIRED: 'Company is required',
        PERMISSIONS: 'Permissions',
        SUFFIX: 'Suffix',
      },
    },
    ROLE_TEMPLATES: {
      ROLE_TEMPLATES: 'Role Templates',
      ROLE_TEMPLATES_LIST: 'Role Template List',
      NEW_ROLE_TEMPLATE: 'Create',
      EDIT_ROLE_TEMPLATE: 'Edit',
      EDIT: {
        UPDATE_MESSAGE: 'Role Template has been updated',
        ADD_MESSAGE: 'Role Template has been created',
      },
      FORM: {
        TITLE: 'Title',
        COMPANY: 'Company',
        DT_CREATED: 'Date and Time Created',
        DT_UPDATED: 'Date and Time Updated',
        TITLE_REQUIRED: 'Title is required',
        PERMISSIONS: 'Permissions',
        SUFFIX: 'Suffix',
      },
      DELETE_ROLE_TEMPLATE_SIMPLE: {
        TITLE: 'Role Template Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this role template?',
        WAIT_DESCRIPTION: 'Role Template is deleting...',
        MESSAGE: 'Role Template has been deleted',
      },
      ACTIVATE_ROLE_TEMPLATE_SIMPLE: {
        TITLE: 'Role Template Activate',
        DESCRIPTION: 'Are you sure you want to activate this role template?',
        WAIT_DESCRIPTION: 'Role Template is activating...',
        MESSAGE: 'Role Template has been activated',
      },
      DELETE_ROLE_TEMPLATE_MULTI: {
        TITLE: 'Role Templates Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete the selected role templates?',
        WAIT_DESCRIPTION: 'Role Templates are deleting...',
        MESSAGE: 'Selected role templates have been deleted',
      },
      TABLE: {
        STATUS: 'Status',
      },
    },
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
      ACTIVITY_LOG: 'Activity Log',
      LOGIN_LOG: 'Login Log',
      ALLOWED_ORIGINS: 'Allowed Origins',
      MANAGEMENT: 'Management',
      COMPANY: 'Company',
      CONTACT: 'Contact',
      DOCTOR: 'Doctor',
      OFFICE: 'Office',
      SERVICE_CATALOG: 'Catalog',
      USER_MANAGEMENT: 'User Management',
      AGREEMENT_MANAGEMENT: 'Agreement Management',
      LINK_MANAGEMENT: 'Link Management',
      USER: 'User',
      ROLE: 'Role',
      ROLE_TEMPLATES: 'Role Templates',
      LISTS: 'Lists',
      AGREEMENT_LIST: 'Agreement List',
      AGREEMENT_TEMPLATE: 'Agreement Template',
      FACILITY: 'Facility',
      PATIENT: 'Patient',
      AFFILIATION: 'Affiliation',
      AFFILIATION_TYPE: 'Affiliation Type',
      INSURANCE: 'Insurance',
      REASON: 'Reason',
      EVENT: 'Event',
      EVENTS: 'Events',
      WORKFLOW: 'Workflow',
      WORKFLOW_GROUP: 'Workflow Group',
      API: 'API',
      ACTION: 'Action',
      DRUG_GROUP: 'Drug Group',
      DRUG: 'Drug',
      DRUG_LIST: 'Drug List',
      PHARMACY: 'Pharmacy',
      PHARMACY_LIST: 'Pharmacy List',
      PHARMACY_GROUP: 'Pharmacy Group',
      FACILITY_CONTACTS: 'Facility Contacts',
      MOBILE_CONTACTS: 'Mobile Contacts',
      CLIENT: 'Client',
      DEVICES_LIST: 'Device list',
      INBOX: 'Inbox',
      FAX: 'Fax',
      EMAIL: 'Email',
      TAGS: 'Tags',
      CATEGORY: 'Category',
      CONTACT_RELATIONSHIP: 'Lookup Lists',
      RELATIONSHIP_CATEGORY: 'Relationship Category',
      REASON_DRP: 'Reason DRP',
      REASON_FOLLOWUP: 'Reason Follow-up',
      CATEGORY_DESCRIPTION: 'Category Description',
      LEGACY_WORKFLOWS: 'Legacy Workflows',
      TEMPLATE: 'Task Template',
      LINKS: 'Links',
      LINK_GROUPS: 'Link Groups',
      MED_REVIEW: 'Med Review',
      MANAGE_NOTIFICATIONS: 'Manage Notifications',
      BRIDGEPAY: {
        TITLE: 'Bridgepay',
        TRANSACTION_HISTORY: 'Transaction History',
      },
      COMPLIANCE: {
        TITLE: 'Compliance',
        AGENCIES: 'Agencies',
        PROGRAMS: 'Programs',
        STANDARDS: 'Standards',
        REPORTING: 'Reporting',
      },
      ACTIVITY_TRACKING: 'Activity Tracking',
      ACTIVITY_TEMPLATES: 'Activity Templates',
      ACTIVITIES: 'Activities',
      STATEMENTS_COLLECTIONS: 'Statements & Collections',
      STATEMENTS: 'Statements',
      TEMPLATES_MAPPING: 'Templates Mapping',
      SETTINGS: 'Settings',
      COMMUNICATIONS: 'Communications',
      WORKOS: 'WorkOS',
    },
    AUTH: {
      PASSWORD_VALID:
        'Password should be a combination of uppercase, lower case, special char, digit and min 8 , max 20 char long',
      PASSWORD_LENGTH:
        'Password should be a combination of uppercase, lower case, special char, digit and min 8 , max 20 char long',
      USERNAME_VALID: "Username's first character must be lowercase or uppercase",
      USERNAME_LENGTH: 'Invalid Username Length. Username must be at least 4 characters long',
      USER_NO_ROLE: "The user can't login, please add a role for this user to be able to login",
      NEW_PASSWORD_VALID:
        'New Password should be a combination of uppercase, lower case, special char, digit and min 8 , max 20 char long',
      OLD_PASSWORD_VALID:
        'Old Password should be a combination of uppercase, lower case, special char, digit and min 8 , max 20 char long',
      PASSWORD_UPDATED: 'Password Successfully Updated',
      PASSWORD_NOT_MATCH: ' Current Password is invalid',
      NOT_FOUND: 'No such user found',
      AUTH_FAILED: "Authentication Failed! Password or Username doesn't match",
      TOKEN_EXPIRED: 'Token Expired',
      NOT_ACTIVE: 'User not Active',
      EMAIL: 'Invalid Email!',
      EXIST: 'This  user is exist',
      REFRESH_TOKEN_MATCH: "Authentication Failed! Token  doesn't match",
      REFRESH_TOKEN_EXIST: 'You do not have the refresh token, please login again',
      NEW_PASSWORD_LENGTH:
        'Invalid Password, New Password should be between 8 to 20 characters long',
      OLD_PASSWORD_LENGTH:
        'Invalid Password, Old Password should be between 8 to 20 characters long',
      NEW_PASSWORD_VALUE: 'Password changed accepted',
      USER_NO_ROLETYPE:
        "The user can't login, please add the role type for this user to can access a login",
      FIRSTNAME_LENGTH: 'Invalid First name.First name must be at least 2 characters long',
      LASTNAME_LENGTH: 'Invalid Last name.Last name must be at least 2 characters long',
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
        WELCOME_MSG: 'Enter your Email and Password',
        ENTER_PASS: 'Enter your password',
        ENTER_EMAIL: 'Enter your email',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your Email',
        SUCCESS: 'Your account has been successfully reset.',
      },
      RESET: {
        TITLE: 'Reset password',
        MOBILE_TITLE: 'Reset Mobile password',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
        MOBILE_SUCCESS: 'Your password has been successfully reset.',
        BUTTON: 'Reset',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EDIT: 'Edit',
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
        NEW_PASSWORD: 'New Password',
        CURRENT_PASS: 'Current Password',
        CHANGE_PASS: 'Change Password',
        BASIC_INFO: 'General Info',
        BACK: 'Back',
        SAVE: 'Save',
        CREATE: 'Create',
        CANCEL: 'Cancel',
        SEND: 'Send',
        ROLE: 'Roles',
        EMAIL_USERNAME: 'Email',
        ASSIGN: 'Assign',
        ASSIGN_TIME: 'Assign time',
      },
      VALIDATION: {
        INVALID_STATE: 'invalid state',
        INVALID: ' is not valid',
        REQUIRED: ' is required',
        REQUIREDD: ' is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        PATTERN: 'Invalid Pattern',
        PATTERN_PASSWORD:
          'Password should be a combination of uppercase, lowercase, special character, digit, 8-20 chars.',
        NOT_MATCH: "Passwords don't match",
        INVALID_OR_REQUIRED: 'Invalid input or required please check again ',
      },
    },
    SERVICE_CATALOG: {
      LIST: 'Service Catalog List',
      NEW: 'New Service Catalog',
      EDIT: 'Edit Service Catalog',
      REORDER: 'Reorder catalogs',
      TEMPLATES: 'Task Templates',
      NAME_MAX: 'Name must be 255 characters or fewer',
      DESCRIPTION_MAX: 'Description must be 500 characters or fewer',
      TABLE: {
        ORDER: 'Order',
        NAME: 'Name',
        DESCRIPTION: 'Description',
        ENTITY_TYPES: 'Entity Types',
      },
      DELETE: {
        TITLE: 'Service Catalog Delete',
        DESCRIPTION: 'Are you sure you want to delete this service catalog?',
        WAIT_DESCRIPTION: 'Service catalog is deleting...',
      },
    },
    OFFICE: {
      OFFICE: 'Office',
      OFFICES: 'Offices',
      OFFICES_LIST: 'Office List',
      NEW_OFFICE: 'New Office',
      EDIT_OFFICE: 'Edit Office',
      VIEW_OFFICE: 'View Office',
      DUPLICATE_ENTRY: 'Duplicate Entry For office name',
      ESIG_ALREADY_ENABLED: 'Electronic Signature Already Enabled For Office',
      UPDATED: 'Office Successfully Updated',
      STATUS_UPDATED: 'Office Status Successfully Updated',
      DELETED: 'Office Successfully Deleted',
      LIMIT: 'You can not add more offices, You have exceeded the limit',
      NAME_LENGTH: 'Invalid name! Office name must be at least 2 characters long',
      DELETE_OFFICE_SIMPLE: {
        TITLE: 'Office Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this office?',
        WAIT_DESCRIPTION: 'Office is deleting...',
        MESSAGE: 'Office has been deleted',
      },
      DELETE_OFFICE_MULTI: {
        TITLE: 'Offices Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete the selected offices?',
        WAIT_DESCRIPTION: 'Offices are deleting...',
        MESSAGE: 'Selected offices have been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Office Status Update',
        DESCRIPTION: "Are you sure you want to change the office's status?",
        WAIT_DESCRIPTION: 'Office status is updating...',
        MESSAGE: 'Office status has successfully been updated',
      },
      UPDATE_STATUS_MULTI: {
        TITLE: 'Offices Status Update',
        MESSAGE: 'Offices status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Office has been updated',
        ADD_MESSAGE: 'Office has been created',
      },
      TABLE: {
        STATUS: 'Status',
        NAME: 'Name',
        PHONE: 'Phone',
        FAX: 'Fax',
        OFFICENO: 'Office No',
        CITY: 'City',
        STATE: 'State',
      },
      FORM: {
        NAME: 'Name',
        ADDRESS: 'Address',
        STATUS: 'Office Status',
        USE_BOLDSIGN: 'Use BoldSign Document Signing',
        PHONE: 'Phone',
        FAX: 'Fax',
        NAME_REQUIRED: 'Name is required',
        ADDRESS_REQUIRED: 'Address is required',
        PREFIX: 'Prefix',
        SUFFIX: 'Suffix',
      },
    },
    PROG_ELIG: {
      PROG_ELIG: 'Program Eligibility',
    },
    PROG_PART: {
      PROG_PART: 'Program Participant',
      PROG_PARTS: 'Program Participants',
      PROG_PARTS_LIST: 'Program Participant list',
      NEW_PROG_PART: 'New Program Participant',
      EDIT_PROG_PART: 'Edit Program Participant',
      UPDATED: 'Program Participant Successfully Updated',
      DELETED: 'Program Participant Successfully Deleted',
      DELETE_PROG_PART_SIMPLE: {
        TITLE: 'Program Participant Delete',
        DESCRIPTION: 'Are you sure you want to permanently program participant this office?',
        WAIT_DESCRIPTION: 'Program Participant is deleting...',
        MESSAGE: 'Program Participant has been deleted',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Program Participant has been updated',
        ADD_MESSAGE: 'Program Participant has been created',
      },
      INPUT: {
        PATIENT: 'Patient',
        PROGRAM: 'Program',
        DEVICE: 'Device',
      },
    },
    DRUG_REL: {
      DRUG_REL: 'Drug',
      DRUG_RELS: 'Drug',
      DRUG_RELS_LIST: 'Drug list',
      NEW_DRUG_REL: 'New Drug',
      EDIT_DRUG_REL: 'Edit Drug',
      UPDATED: 'Drug Successfully Updated',
      DELETED: 'Drug Successfully Deleted',
      EDIT: {
        UPDATE_MESSAGE: 'Drug has been updated',
        ADD_MESSAGE: 'Drug has been created',
      },
    },
    PROBLEM: {
      PROBLEM: 'Problem',
      PROBLEMS: 'Problems',
      PROBLEMS_LIST: 'Problem list',
    },
    COMPANY: {
      COMPANY: 'Company',
      COMPANIES: 'Companies',
      COMPANIES_LIST: 'Companies List',
      ADD_COMPANY: 'Add Company',
      EDIT_COMPANY: 'Edit Company',
      VIEW_COMPANY: 'View Company',
      IMPERIAL: 'Imperial',
      METRIC: 'Metric',
      DUPLICATE_ENTRY: 'Duplicate Entry For company name',
      CONFLICT_OFFICE:
        'Conflict! You must delete some offices related with this company to fit with limit number of offices',
      CONFLICT_USER:
        'Conflict! You must delete some users related with this company to fit with limit number of users',
      UPDATED: 'Company Successfully Updated',
      STATUS_UPDATED: 'Company Status Successfully Updated',
      DELETED: 'Company Successfully Deleted',
      NAME_LENGTH: 'Invalid name! Company name must be at least 2 characters long',
      DELETE_COMPANY_SIMPLE: {
        TITLE: 'Company Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this company?',
        WAIT_DESCRIPTION: 'Company is deleting...',
        MESSAGE: 'Company has been deleted',
      },
      DELETE_COMPANY_MULTI: {
        TITLE: 'Companies Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete selected companies?',
        WAIT_DESCRIPTION: 'Companies are deleting...',
        MESSAGE: 'Selected companies have been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Company Status Update',
        DESCRIPTION: "Are you sure you want to change the Company's status?",
        WAIT_DESCRIPTION: 'Company status is updating...',
        MESSAGE: 'Company status has successfully been updated',
      },
      UPDATE_STATUS_MULTI: {
        TITLE: 'Companies Status Update',
        MESSAGE: 'Companies status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Company has been updated',
        ADD_MESSAGE: 'Company has been created',
      },
      TABLE: {
        ID: 'ID',
        ADMIN: 'Admin',
        STATUS: 'Status',
        NAME: 'Name',
        COMPANY_NAME: 'Company Name',
        ADMIN_NAME: 'Admin Name',
      },
      FORM: {
        NAME: 'Name',
        OFFICE_LIMIT: 'Office number limit',
        USER_LIMIT: 'User number limit',
        MEASURMENT_SYSTEM: 'Measurement System',
        EMAIL: 'Email',
        PHONE: 'Phone',
        TECHNICAL_LEAD: 'Technical Lead',
        OPERATION_LEAD: 'Operation Lead',
        PHARMACY_LEAD: 'Pharmacy Lead',
        STATUS: 'Company Status',
        DT_CREATED: 'Date and Time Created',
        DT_UPDATED: 'Date and Time Updated',
        NAME_REQUIRED: 'Name is required',
        OFFICE_LIMIT_ERROR:
          "Office limit cannot be smaller than the current no. of the company's active offices",
        USER_LIMIT_ERROR:
          "User limit cannot be smaller than the current no. of the company's active users",
        EMAIL_ERORR: 'Invalid email pattern',
        INVALID_PHONE: 'Phone must be numeric and between 7 and 15 characters',
        ORGANIZATION_DETAILS: 'BridgePay Organization Details',
        CREATE_ORGANIZATION: 'Create Organization',
      },
    },
    CONTACT: {
      CONTACT: 'Contact',
      CONTACTS: 'Contacts',
      CONTACTS_LIST: 'Contacts List',
      ADD_CONTACT: 'Add Contact',
      ADD_RELATIONSHIP: 'Add Relationship',
      NEW_CONTACT: 'New Contact',
      EDIT_CONTACT: 'Edit Contact',
      VIEW_CONTACT: 'View Contact',
      DUPLICATE_ENTRY: 'Duplicate Entry For contact name',
      UPDATED: 'Contact Successfully Updated',
      STATUS_UPDATED: 'Contact Status Successfully Updated',
      DELETED: 'Contact Successfully Deleted',
      NAME_LENGTH: 'Invalid name! Contact name must be at least 2 characters long',
      DELETE_CONTACT_SIMPLE: {
        TITLE: 'Contact Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this contact?',
        WAIT_DESCRIPTION: 'Contact is deleting...',
        MESSAGE: 'Contact has been deleted',
      },
      DELETE_CONTACT_MULTI: {
        TITLE: 'Contacts Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete selected contacts?',
        WAIT_DESCRIPTION: 'Contacts are deleting...',
        MESSAGE: 'Selected contacts have been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Contact Status Update',
        DESCRIPTION: "Are you sure you want to change the Contact's status?",
        WAIT_DESCRIPTION: 'Contact status is updating...',
        MESSAGE: 'Contact status has successfully been updated',
      },
      UPDATE_STATUS_MULTI: {
        TITLE: 'Contacts Status Update',
        MESSAGE: 'Contacts status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Contact has been updated',
        ADD_MESSAGE: 'Contact has been created',
      },
      TABLE: {
        ID: 'ID',
        CONTACT: 'Contact',
        NAME_EMAIL: 'Name/Email',
        USER_NAME: 'Username',
        CELL_PHONE: 'Cell Phone',
        TYPES: 'Type/s',
        PHONE: 'Phone',
        FAX: 'Fax',
        EMAIL: 'Email',
        STATUS: 'Status',
        NAME: 'Name',
      },
      FORM: {
        BASIC_INFO: 'Basic Info',
        FIRSTNAME: 'First Name',
        LASTNAME: 'Last Name',
        LASTNAME_MATERNAL: 'Last Name Maternal',
        ENTITY_TYPE: 'Entity Type',
        CONTACT_STATUS: 'Contact Status',
        CONTACT_DETAILS: 'Contact Details',
        EMAIL: 'Email',
        HOMEPHONE: 'Home Phone',
        CELLPHONE: 'Cell Phone',
        FAX: 'Fax',
        ADDRESS: 'Address',
        ADDRESS1: 'Address 1',
        ADDRESS2: 'Address 2',
        STATE: 'State',
        CITY: 'City',
        ZIP: 'Zip',
        OTHER: 'Other',
        NOTE: 'Note',
      },
    },
    CONTACT_RELATIONSHIP: {
      CONTACT_RELATIONSHIPS: 'Contact Relationships',
      CONTACT_RELATIONSHIPS_LIST: 'Contact Relationships list',
      CREATE_CONTACT_RELATIONSHIP: 'New Relationship',
      NEW_CONTACT_RELATIONSHIP: 'New Relationship',
      EDIT_CONTACT_RELATIONSHIP: 'Edit Relationship',
      VIEW_CONTACT_AGREEMENTS: 'View Agreements',
      DUPLICATE_ENTRY: 'Duplicate Entry For contact relationship',
      DELETE_CONTACT_RELATIONSHIP_SIMPLE: {
        TITLE: 'Contact Relationship Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this contact relationship?',
        WAIT_DESCRIPTION: 'Contact Relationship is deleting...',
        MESSAGE: 'Contact Relationship has been deleted',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Relationship has been updated',
        ADD_MESSAGE: 'Relationship has been created',
      },
      TABLE: {
        NAME: 'Name',
        ENTITY_TYPE: 'Entity Type',
        RELATION_TYPE: 'Type',
        DESCRIPTION: 'Description',
        DATE_CREATED: 'Date Created',
        CLASSIFICATION: 'Classification',
      },
      FORM: {
        ENTITY_TYPE: 'Entity Type',
        RELATION_TYPE: 'Type',
        SEARCH_ENTITIES: 'Search Entities',
        DESCRIPTION: 'Description',
        CONFLICT: 'There is already and existing relationship between the contact and this entity',
        VALUE_REQUIRED: 'Value is required',
      },
    },
    ENTITY: {
      ALL_ENTITIES: 'All Entities',
      DOCTOR: 'Doctor',
      PATIENT: 'Patient',
      FACILITY: 'Facility',
      CONTACT: 'Contact',
      CLIENT: 'Client',
      SELECT_ENTITIES: 'Select Entities',
      AFFILIATION: 'Affiliation',
    },
    PATIENT: {
      PATIENT: 'Patient',
      PATIENT_NAME: 'Patient name',
      PATIENTS_LIST: 'Patients List',
      RESIDENTS_LIST: 'Residents List',
      ADD_PATIENT: 'Add Patient',
      VIEW_IMAGE_REQUESTS: 'Image Requests',
      EDIT_PATIENT: 'Edit Patient',
      NEW_PATIENT: 'New Patient',
      VIEW_PATIENT: 'View Patient',
      UPDATED: 'Patient Successfully Updated',
      STATUS_UPDATED: 'Patient Status Successfully Updated',
      DELETED: 'Patient Successfully Deleted',
      IMAGE_REQUESTS: {
        APPROVE_REQUEST_SIMPLE: {
          TITLE: 'Approve Request',
          DESCRIPTION: 'Are you sure you want to approve this request?',
          WAIT_DESCRIPTION: 'Request is approving...',
          MESSAGE: 'Request has been approved.',
        },
        DENY_REQUEST_SIMPLE: {
          TITLE: 'Deny Request',
          DESCRIPTION: 'Are you sure you want to deny this request?',
          WAIT_DESCRIPTION: 'Request is denying...',
          MESSAGE: 'Request has been denied.',
        },
        STATUS: {
          APPROVED: 'Approved',
          DENIED: 'Denied',
          PENDING: 'Pending',
          CANCELED: 'Canceled',
        },
      },
      DELETE_PATIENT_SIMPLE: {
        TITLE: 'Patient Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this patient?',
        WAIT_DESCRIPTION: 'Patient is deleting...',
        MESSAGE: 'Patient has been deleted',
      },
      DELETE_PATIENT_MULTI: {
        TITLE: 'Patients Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete selected patients?',
        WAIT_DESCRIPTION: 'Patient are deleting...',
        MESSAGE: 'Selected Patients have been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Patient Status Update',
        DESCRIPTION: "Are you sure you want to change the Patient's status?",
        WAIT_DESCRIPTION: 'Patient status is updating...',
        MESSAGE: 'Patient status has successfully been updated',
      },
      UPDATE_STATUS_MULTI: {
        TITLE: 'Patients Status Update',
        MESSAGE: 'Patients status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Patient has been updated',
        ADD_MESSAGE: 'Patient has been created',
      },
      INPUT: {
        ID: 'ID',
        NAME_EMAIL: 'Name/Email',
        FIRST_NAME: 'First Name',
        MIDDLE_NAME: 'Middle Name',
        LAST_NAME: 'Last Name',
        LAST_NAME_2: 'Last Name 2',
        DOB: 'Date of Birth',
        STATUS: 'Status',
        HOLD_HOSPITAL: 'Hold/Hospital',
        GENDER: 'Gender',
        PRIMARY_LANGUAGE: 'Primary Language',
        ALLOWED_OFFICES: 'Allowed offices',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm password',
        ROLE: 'Role',
        NEW_USER: 'Create new user',
        USER_LIST: 'Users list',
        PATIENT_CLASS: 'Patient Class',
        FACILITY: 'Facility',
        FACILITIES: 'Facilities',
        ADDRESS_1: 'Address 1',
        ADDRESS_2: 'Address 2',
        CITY: 'City',
        STATE: 'State',
        ZIP: 'ZIP',
        URBANIZATION: 'Urbanization',
        HOME_PHONE: 'Home Phone',
        CELL_PHONE: 'Cell Phone',
        FAX: 'Fax',
        EMAIL: 'Email',
        PATIENT_DEMOGRAPHICS: 'Patient Demographics',
        ADDRESS_AND_PHONE: 'Address and Phone',
        OTHER_DETAILS: 'Other Details',
        HOLD_FLAG: 'Hold Flag',
        HOLD_DATE: 'Hold Date',
        HOLD_NOTE: 'Hold Note',
        IN_HOSPITAL: 'In Hospital',
        IN_HOSPITAL_DATE: 'In Hospital Date',
        IN_HOSPITAL_NOTE: 'In Hospital Note',
        IS_ACTIVE: 'Is Active',
        MALE: 'Male',
        FEMALE: 'Female',
        BACK: 'Back to patient list',
        RESET: 'Reset Patient',
        SAVE: 'Save & Continue',
        BASIC_INFO: 'Basic Input',
        WEIGHT_KG: 'Weight (kg)',
        WEIGHT_LB: 'Weight (lb)',
        WEIGHT_HISTORY: 'Weight History/ New Weight',
        HEIGHT_FEET: 'Height (feet)',
        HEIGHT_INCH: 'Height (inch)',
        HEIGHT_CM: 'Height (cm)',
        HEIGHT_HISTORY: 'Height History/ New Height',
        LAST_MODIFIED: 'Last Modified',
        LAST_MODIFIED_USER: 'Last Modified User',
        INSURANCE: {
          INSURANCE_LIST: 'Insurance List',
          EDIT_PATIENT_INSURANCE: 'Edit Insurance',
          NEW_PATIENT_INSURANCE: 'Create Insurance',
          VIEW_PATIENT_INSURANCE: 'View Insurance',
          UPDATED_MESSAGE: 'Patient Insurance Successfully Updated',
          DELETED_MESSAGE: 'Patient Insurance Successfully Deleted',
          CREATED_MESSAGE: 'Patient Insurance Successfully Created',
          INSURANCE_TITLE: 'Insurance',
          INSURANCE_NUMBER: 'Insurance Number',
          INSURANCE_ID: 'Insurance id',
          PLAN_NAME: 'Plan Name',
          GROUP: 'Group',
          PERSON_CODE: 'Person Code',
          PRIORITY: 'Priority',
          IS_ACTIVE: 'Is Active',
          STATUS: 'Status',
        },
      },
      PLACEHOLDER: {
        CELL_PHONE: 'Enter Cell Phone',
      },
      VALIDATION: {
        REQUIRED: 'is Required',
        PATTERN: 'is not valid',
        EMAIL: 'is not valid',
        INVALID: 'is not valid',
        INVALID_OR_REQUIRED: 'Invalid input or required please check again',
      },
      TABLE: {
        PATIENT_ID: 'Patient Id',
        HOME_PHONE: 'Home Phone',
        EMAIL: 'Email',
        STATUS: 'Status',
        NAME: 'Name',
        DOB: 'DOB',
        FILTER: 'Filter',
        BY_STATUS: 'Status',
        HOLD_HOSPITAL: 'Hold/Hospital',
        BY_HOLD_HOSPITAL: 'Hold/Hospital',
      },
      BUTTON: {
        BACK: 'Back',
        RESET: 'Reset',
        SAVE: 'Save',
      },
      FILTER: {
        ALL: 'All',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        HOSPITAL: 'Hospital',
        HOLD: 'Hold',
      },
      PATIENT_WEIGHT: {
        WEIGHT_LIST: 'Weight List',
        CLOSE_DIALOG: 'Close',
        TABLE: {
          NEW_WEIGHT: 'New Weight',
          WEIGHT_KG: 'Weight (kg)',
          WEIGHT_LB: 'Weight (lb)',
          START_DATE: 'Start Date',
          PLEASE_ENTER: 'Please enter',
        },
        EDIT: {
          ADD_MESSAGE: 'Weight has been created',
        },
      },
      PATIENT_HEIGHT: {
        HEIGHT_LIST: 'Height List',
        CLOSE_DIALOG: 'Close',
        TABLE: {
          NEW_HEIGHT: 'New Height',
          HEIGHT_FT: 'Height (ft)',
          HEIGHT_IN: 'Height (in)',
          HEIGHT_CM: 'Height (cm)',
          START_DATE: 'Start Date',
          PLEASE_ENTER: 'Please enter',
        },
        EDIT: {
          ADD_MESSAGE: 'Height has been created',
        },
      },
    },
    USER: {
      INPUT: {
        NAME: 'Name',
        FIRST_NAME: 'First Name',
        LAST_NAME: 'Last Name',
        USERNAME: 'Username',
        EMAIL: 'Email',
        STATUS: 'Status',
        COMPANY: 'Company',
        PRIMARY_OFFICE: 'Primary Office',
        ALLOWED_OFFICES: 'Allowed Offices',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        ROLE: 'Role',
        NEW_USER: 'Create new user',
        USER_LIST: 'Users list',
      },
      NAME: 'Name',
      USERNAME: 'Username',
      EMAIL: 'Email',
      ROLE: 'Role',
      COMPANY: 'Company',
      STATUS: 'Status',
      INFO: 'User information',
      EMAIL_DUPLICATE_ENTRY: 'Duplicate Entry For Email',
      USERNAME_DUPLICATE_ENTRY: 'Duplicate Entry For Username',
      ADDED: 'User Successfully Added',
      LIMIT: 'You can not add more users, You have exceeded the limit',
      UPDATED: 'User Successfully Updated',
      STATUS_UPDATED: 'User Status Successfully Updated',
      DELETED: 'User Successfully Deleted',
    },
    ACTIVITY: {
      LIST: 'Activity list',
      NAME: 'Table name',
      CAUSER: 'User',
      LOG_DESC: 'Description',
      LOG_AT: 'Date',
      SUBJECT_NAME: 'Company',
    },
    LOGIN: {
      LIST: 'Login History list',
      COMPANY: 'Company',
      USER: 'User',
      IP_ADDRESS: 'IP Address',
      DATE: 'Date',
      DESCRIPTION: 'Description',
    },
    TABLE: {
      MAPPING: 'Map',
      ALLERGY_LIST: 'Allergy list',
      ADD_ALLERGY: 'New Allergy',
      ADD_CONDITION: 'New Condition',
      NO_RECORDS: 'No records found',
      PLAESE_WAIT: 'Please wait ...',
      PLEASE_WAIT: 'Please wait...',
      SEARCH: 'Search',
      IN_ALL_FIELDS: ' in All Fields',
      IN_DESCRIPTIONS: 'in Descriptions',
      FILTER: 'Filter',
      BY_STATUS: 'Status',
      BY_OFFICE: 'Office',
      STATUS: 'Status',
      ADD_USER: 'New User',
      USER_LIST: 'Users List',
      ADD: 'Add',
      CREATE: 'Create',
      UPDATE: 'Edit',
      ACTIVATE_DEACTIVATE: 'Activate/Deactivate',
      DELETE: 'Delete',
      VIEW: 'View',
      REVIEW: 'Review',
      ATTACH: 'Attach',
      SHARE: 'Share',
      DUPLICATE: 'Duplicate',
      DOWNLOAD: 'Download',
      ACTIONS: 'Actions',
      CLOSE: 'Close',
      SEND: 'Send',
      ADD_DOCTOR: 'Add Doctor',
      ADD_MEETING: 'New Meeting',
      ADD_MESSAGE: 'New message',
      DOCTORS_LIST: 'Doctors List',
      MESSAGE_LIST: 'Message list',
      MEETING_LIST: 'Sales Calls list',
      NOTE_LIST: 'Note list',
      INSURANCE_LIST: 'Insurance list',
      Tags_LIST: 'Tags List',
      WORKFLOW_LIST: 'Workflow list',
      EVENT_LIST: 'Event list',
      EVENTACTION_LIST: 'Action list',
      ADD_AFFILIATION_TYPE: 'New affiliation type',
      ADD_INSURANCE: 'New insurance',
      ADD_TAGS: 'New Tags',
      ADD_WORKFLOW: 'New Workflow',
      ADD_EVENT: 'New Event',
      ADD_EVENTACTION: 'New Action',
      ADD_WORKFLOW_GROUP: 'New Workflow Group',
      ADD_API: 'New API',
      API_LIST: 'API list',
      WORKFLOW_ACTIONS_LIST: 'Workflow actions',
      ADD_WORKFLOW_ACTION: 'New workflow action',
      PR_LIST: 'Roles list',
      ADD_PR: 'New role ',
      WORKFLOW_GROUP_LIST: 'Workflow group list',
      ADD_IMMUNIZATION: 'New Immunization',
      DOC_LIB_LIST: 'Document Library List',
      ADD_DOC_LIB: 'Upload Marketing document',
      AFFILIATION_TYPE_LIST: 'Affiliation Type list',
      RELATIONSHIP_LIST: 'Relationship list',
      UPLOAD_MANUAL: 'Manual Upload',
      IN_NOTE: 'in Note field',
      PAYMENT_INFO: 'Payment Info List',
      NOTIFICATION_LIST: 'Notification List',
      ADD_NOTIFICATION: 'New Notification',
      COMPLIANCE: {
        AGENCY_LIST: 'Agency List',
        ADD_AGENCY: 'Add Agency',
        STANDARD_LIST: 'Standard List',
        ADD_STANDARD: 'Add Standard',
        MANAGE_STANDARDS: 'Manage Standards',
        REMOVE_STANDARD: 'Remove Standard',
        PROGRAM_LIST: 'Program List',
        ADD_PROGRAM: 'Add Program',
        REPORTING_LIST: 'Reporting List',
        RETRIEVE_REPORTS: 'Retrieve Reports',
        DOWNLOAD_AS_CSV: 'Download As CSV',
        VIEW_ASSIGNED: 'View Assigned',
      },
      AFFILIATION: {
        RELATIONSHIP_LIST: 'Relationship List',
        NEW_RELATIONSHIP: 'New Relationship',
      },
    },
    TASK_TEMPLATE: {
      TEMPLATES_LIST: 'Task Templates List',
      ADD_TEMPLATE: 'Add Task Template',
      ID: 'ID',
      NAME: 'Name',
      TEAM_CATEGORY: 'Team/Category',
      BACKSTAGE: 'Backstage',
      INTERVENTION: 'Intervention',
      ADDITIONAL_STEP: 'Additional Step',
      ALL_USERS: 'All Users',
      PROCESS_NAV: 'Process Nav',
      ADD_MESSAGE: 'Task Template added successfully',
      UPDATE_MESSAGE: 'Task Template updated successfully',
      DELETE_MESSAGE: 'Task Template has been deleted',
      TITLE: 'Main Task',
      DEFAULT_VIEW: 'Default View',
      DESCRIPTION: 'Description',
      NEW_NAME: 'New Name',
      DUPLICATE_MESSAGE: 'Task Template duplicated successfully',
      DELETE: {
        TITLE: 'Task Template Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this Task Template?',
        WAIT_DESCRIPTION: 'Task Template is deleting...',
      },
      VALIDATION: {
        REQUIRED: '{{label}} field is required',
      },
    },
    API: {
      APIS: 'API',
      ADDED: 'API added successfully',
      UPDATED: 'API updated successfully',
      NEW_API: 'Create API',
      VIEW_API: 'View API',
      EDIT_API: 'Edit API',
      INPUT: {
        NAME: 'Name',
        COMPANY: 'Company',
        METHOD: 'HTTP Method',
        URL: 'URL',
        DESCRIPTION: 'Description',
        PAYLOAD: 'Payload',
      },
      DELETE_API_SIMPLE: {
        TITLE: 'API Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this API?',
        WAIT_DESCRIPTION: 'API is deleting...',
        MESSAGE: 'API has been deleted',
      },
      EDIT: {
        ADD_MESSAGE: 'API created successfully',
        UPDATE_MESSAGE: 'API updated successfully',
      },
    },
    PR: {
      PR_INFO: 'Role Info',
      NEW_PR: 'Create Role',
      EDIT_PR: 'Edit Role',
      ADDED: 'Role created successfully',
      UPDATED: 'Role updated successfully',
      EDIT: {
        ADD_MESSAGE: 'Role created successfully',
        UPDATE_MESSAGE: 'Role updated successfully',
      },
      INPUT: {
        CODE: 'Code',
        PERIOD: 'Period',
        AV_TI: 'Avalible time',
        SPECIALTY: 'Specialty',
        STATUS: 'Status',
        TELECOM: 'Telecom',
        AVAILABILITY: 'Availability',
        NOT_AVAILABLE_DESC: 'Not available description',
        NOT_AVAILABLE_START: 'Not available form',
        NOT_AVAILABLE_END: 'Not available to',
        AVAILABLE_EXCEPTIONS: 'Exceptions',
        EXTRA_DETAILS: 'Extra details',
        HEALTHCARE: 'Healthcare Service',
        DEMOGRAPHICS: 'Basic',
        PERIOD_START: 'Start period',
        PERIOD_END: 'End period',
        ORGAN: 'Organization',
        DAYS: 'Days of week',
      },
      DELETE_PR_SIMPLE: {
        TITLE: 'Role Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this role?',
        WAIT_DESCRIPTION: 'Role is deleting...',
        MESSAGE: 'Role has been deleted',
      },
    },
    DOCTOR: {
      DOCTOR: 'Doctor',
      ADDED: 'Doctor added successfully',
      UPDATED: 'Doctor updated successfully',
      EDIT_DOCTOR: 'Edit doctor',
      NEW_DOCTOR: 'Create doctor',
      VIEW_DOCTOR: 'View doctor',
      DELETE_DOCTOR_MULTI: {
        TITLE: 'Doctors Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete selected doctors?',
        WAIT_DESCRIPTION: 'Doctor are deleting...',
        MESSAGE: 'Selected doctors have been deleted',
      },
      INPUT: {
        ID: 'ID',
        LAST_USER_MOD: 'Last modified user',
        MORE: 'Last modified',
        INFO: 'Doctor information',
        NAME_EMAIL: 'Name/Email',
        FIRST_NAME: 'First name',
        LAST_NAME: 'Last name',
        FULL_NAME: 'Name',
        EMAIL: 'Email',
        STATUS: 'Status',
        OFFICE: 'Office',
        OFFICE_PHONE: 'Office Phone',
        CITY: 'City',
        STATE: 'State',
        ZIP: 'Zip',
        ADDRESS_1: 'Address 1',
        ADDRESS_2: 'Address 2',
        CELL_PHONE: 'Cell phone',
        FAX: 'Fax',
        DEA: 'DEA',
        NPI: 'NPI',
        SLN: 'SLN',
        NOTE: 'Note',
        DOCTOR_ID: 'Source System ID',
        DEMOGRAPHICS: 'Doctor Demographics',
        CONTACTS_AND_ADDRESS: 'Contacts & Address',
        EXTRA_DETAILS: 'Extra details',
        URBANIZATION: 'Urbanization',
      },
      DELETE_DOCTOR_SIMPLE: {
        TITLE: 'Doctor Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this doctor?',
        WAIT_DESCRIPTION: 'Doctor is deleting...',
        MESSAGE: 'Doctor has been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Doctor Status Update',
        DESCRIPTION: 'Are you sure you want to change the doctor status?',
        WAIT_DESCRIPTION: 'Doctor status is updating...',
        MESSAGE: 'Doctor status has successfully been updated',
      },
    },
    MEETING: {
      MEETINGS: 'Sales Call',
      ADDED: 'Meeting added successfully',
      UPDATED: 'Meeting updated successfully',
      EDIT_MEETING: 'Edit Meeting',
      NEW_MEETING: 'Create Meeting',
      INPUT: {
        INFO: 'Meeting Information',
        TIME: 'Time',
        SUBJECT: 'Subject',
        LOCATION: 'Location',
        WITH: 'With',
        DESCRIPTION: 'Description',
        FILES: 'Attachment',
        DATE: 'Created Date',
        START_TIME: 'Start Time',
        END_TIME: 'End Time',
        RESPONSIBLE: 'Responsible Person',
        MEETING_ID: 'Meeting ID',
        DEMOGRAPHICS: 'Meeting Information',
        IS_COMPLETED: 'Is Completed',
        IS_IMPORTANT: 'Is Important',
        RELATED_TO: 'Related To',
        EXTRA_DETAILS: 'Extra Details',
        TYPE: 'Type',
        STATUS: 'Status',
        ORGANIZER: 'Call Organizer',
        RELATED_ENTITIES: 'Related Entities',
        DURATION: 'Duration',
      },
    },
    COMMUNICATION: {
      INPUT: {
        INFO: 'Communication information',
        TIME: 'Created time',
        SENDER: 'Sender name',
      },
    },
    UPLOAD_MARKETING_DOCS: {
      UPLOAD_MARKETING_DOCS: 'Upload Marketing Docs',
      TOPIC: 'Topic',
      DESCRIPTION: 'Description',
      TAGS: 'Tags',
      SELECT_DOCUMENTS: 'Documents',
      SUCCESS: 'Successfully Uploaded',
      CATEGORY: 'Category',
    },
    MESSAGE: {
      MESSAGES: 'Messages',
      ADDED: 'Message added successfully',
      UPDATED: 'Message updated successfully',
      EDIT_MESSAGE: 'Edit message',
      NEW_MESSAGE: 'Create message',
      INPUT: {
        INFO: 'Message information',
        TIME: 'Time',
        SENDER: 'Sender',
        RECEIVER: 'Receiver',
        TAG: 'Tags',
        TEXT: 'Text',
        FILE: 'Attachment',
        MESSAGE_ID: 'Message id',
        DEMOGRAPHICS: 'Message information',
        EXTRA_DETAILS: 'Extra details',
        AFFILIATION: 'Practice Information',
      },
    },

    AFFILIATION: {
      AFFILIATIONS_LIST: 'Affiliations List',
      ADD_AFFILIATION: 'Add Affiliation',
      LINK_AFFILIATION: 'Link Affiliation',
      LINK_AFFILIATION_MESSAGE: 'Affiliation linked successfully',
      UNLINK_AFFILIATION_MESSAGE: 'Affiliation unlinked successfully',
      AFFILIATION: 'Affiliation',
      ADDED: 'Affiliation added successfully',
      UPDATED: 'Affiliation updated successfully',
      AFFILIATIONS: 'Affiliations',
      EDIT_AFFILIATION: 'Edit affiliation',
      EDIT_AFFILIATION_TYPE: 'Edit affiliation type',
      NEW_AFFILIATION: 'Create Affiliation',
      NEW_AFFILIATION_TYPE: 'Create Affiliation type',
      VIEW_AFFILIATION: 'View affiliation',
      INPUT: {
        INFO: 'Affiliation information',
        ID: 'ID',
        NAME: 'Name',
        AFFILIATION_TYPE: 'Affiliation Type',
        SUPERVISING_CONTROL: 'Supervising Control',
        AFFILIATION_TYPE_DESCRIPTION: 'Affiliation type description',
        AFFILIATION_TYPE_NAME: 'Affiliation type name',
        TYPE_DESCRIPTION: 'Description type',
        EMAIL: 'Email',
        STATUS: 'Status',
        COMPANY_ID: 'Company',
        PHONE: 'Phone',
        NOTE: 'Note',
        CITY: 'City',
        STATE: 'State',
        ZIP: 'Zip',
        ADDRESS_1: 'Address 1',
        ADDRESS_2: 'Address 2',
        FAX: 'Fax',
        DESCRIPTION: 'Description',
        DEMOGRAPHICS: 'Affiliation Demographics',
        CONTACTS_AND_ADDRESS: 'Contacts & Address',
        EXTRA_DETAILS: 'Extra details',
      },
      DELETE_AFFILIATION: {
        TITLE: 'Delete Affiliation',
        DESCRIPTION: 'Are you sure you want to permanently delete this affiliation?',
        WAIT_DESCRIPTION: 'Deleting Affiliation...',
        MESSAGE: 'Affiliation deleted successfully',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Affiliation Status Update',
        DESCRIPTION: 'Are you sure you want to change the affiliation status?',
        WAIT_DESCRIPTION: 'Affiliation status is updating...',
        MESSAGE: 'Affiliation status has successfully been updated',
      },
      DELETE_AFFILIATION_TYPE_SIMPLE: {
        TITLE: 'Affiliation type Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this affiliation type?',
        WAIT_DESCRIPTION: 'Affiliation type is deleting...',
        MESSAGE: 'Affiliation type has been deleted',
      },
      EDIT_AFFILIATION_TYPE_MS: {
        ADD_MESSAGE: 'Affiliation type created successfully',
        UPDATE_MESSAGE: 'Affiliation type updated successfully',
      },
      RELATIONS: {
        ADD_MESSAGE: 'Affiliation Relation created successfully',
        UPDATE_MESSAGE: 'Affiliation Relation updated successfully',
        DELETE: {
          TITLE: 'Delete Affiliation Relation',
          DESCRIPTION: 'Are you sure you want to permanently delete this Affiliation Relation?',
          WAIT_DESCRIPTION: 'Deleting Affiliation Relation...',
          MESSAGE: 'Affiliation Relation deleted successfully',
        },
      },
    },

    INSURANCE: {
      INSURANCE: 'Insurances',
      ADDED: 'Insurance added successfully',
      UPDATED: 'Insurance updated successfully',
      INSURANCES: 'Insurance',
      EDIT_INSURANCE: 'Edit Insurance',
      NEW_INSURANCE: 'Create insurance',
      INPUT: {
        INFO: 'Insurance information',
        NAME: 'Name',
        INSURANCE_TYPE: 'Insurance type ',
        SUBMISSION_TYPE: 'Submission type ',
        PHONE: 'Phone',
        BIN: 'BIN',
        PCN: 'PCN',
        FAX: 'Fax',
        ID: 'Id',
      },
      DELETE_INSURANCE_SIMPLE: {
        TITLE: 'Insurance Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this insurance?',
        WAIT_DESCRIPTION: 'Insurance is deleting...',
        MESSAGE: 'Insurance has been deleted',
      },
    },
    WORKFLOW_GROUP: {
      WORKFLOW_GROUP: 'Workflow group',
      NEW_WORKFLOW_GROUP: 'Create workflow group',
      EDIT_WORKFLOW_GROUP: 'Edit workflow group',
      NEW_WORKFLOW: 'Create workflow',
      EDIT_WORKFLOW: 'Edit workflow',
      ADDED: 'Workflow added successfully',
      UPDATED: 'Workflow updated successfully',
      WORKFLOW_ACTIONS: 'Workflow action',
      NEW_WORKFLOW_ACTION: 'Create workflow action',
      EDIT_WORKFLOW_ACTION: 'Edit workflow action',
      ADDED_ACTION: 'Workflow action added successfully',
      UPDATED_ACTION: 'Workflow action updated successfully',
      INPUT: {
        NAME: 'Name',
        COMPANY_ID: 'Company id',
        COMPANY_NAME: 'Company',
        EVENT: 'Event',
        DESCRIPTION: 'Description',
        STATUS: 'Status',
        ACTION: 'Action',
        API: 'API',
        FORM: 'Form',
      },
      EDIT: {
        ADD_MESSAGE: 'Workflow group created successfully',
        UPDATE_MESSAGE: 'Workflow group updated successfully',
        STATUS: 'New Status',
      },
    },
    WORKFLOW: {
      WORKFLOWS: 'Workflow',
      NEW_WORKFLOW: 'Create workflow',
      EDIT_WORKFLOW: 'Edit workflow',
      ADDED: 'Workflow added successfully',
      UPDATED: 'Workflow updated successfully',
      WORKFLOW_ACTIONS: 'Workflow action',
      NEW_WORKFLOW_ACTION: 'Create workflow action',
      EDIT_WORKFLOW_ACTION: 'Edit workflow action',
      ADDED_ACTION: 'Workflow action added successfully',
      UPDATED_ACTION: 'Workflow action updated successfully',
      CANCEL: 'Cancel',
      RECREATE: 'Recreate',
      CANCEL_PROMPT: 'Are you sure you want to cancel this workflow?',
      RECREATE_PROMPT: 'Are you sure you want to recreate this workflow?',
      CANCEL_REASON: 'Please enter the reason for cancellation below:',
      RECREATE_REASON: 'Please enter the reason for recreation below:',
      INPUT: {
        NAME: 'Name',
        COMPANY_ID: 'Company id',
        COMPANY_NAME: 'Company',
        EVENT: 'Event',
        DESCRIPTION: 'Description',
        STATUS: 'Status',
        ACTION: 'Action',
        API: 'API',
        FORM: 'Form',
      },
      FORM: {
        NAME: 'Name is required',
        COMPANY: 'Company is required',
        EVENT: 'Event is required',
        DESCRIPTION: 'Description is required',
        ACTION: 'Action is required',
        API: 'API is required',
        FORM: 'Form is required',
        STATUS: 'Status is required',
        WORKFLOW_GROUP: 'Workflow group is required',
      },
      DELETE_WORKFLOW_SIMPLE: {
        TITLE: 'Workflow Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this workflow?',
        WAIT_DESCRIPTION: 'Workflow is deleting...',
        MESSAGE: 'Workflow has been deleted',
      },
      DELETE_WORKFLOW_ACTION_SIMPLE: {
        TITLE: 'Workflow action Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this workflow action?',
        WAIT_DESCRIPTION: 'action is deleting...',
        MESSAGE: 'Workflow action has been deleted',
      },
      EDIT: {
        ADD_MESSAGE: 'Workflow created successfully',
        UPDATE_MESSAGE: 'Workflow updated successfully',
      },
      EDIT_ACTION: {
        ADD_MESSAGE: 'Workflow action created successfully',
        UPDATE_MESSAGE: 'Workflow action updated successfully',
      },
    },
    EVENT: {
      EVENTS: 'Event',
      NEW_EVENT: 'Create event',
      EDIT_EVENT: 'Edit event',
      ADDED: 'Event added successfully',
      UPDATED: 'Event updated successfully',
      INPUT: {
        NAME: 'Name',
        COMPANY_ID: 'Company id',
        COMPANY_NAME: 'Company',
        EVENT: 'Event',
        DESCRIPTION: 'Description',
        STATUS: 'Status',
        RESPONSIBLE: 'Responsible',
        VISIBLE: 'Visibility',
        DUE_DATE: 'Due date',
      },
      FORM: {
        NAME: 'Name is required',
        COMPANY: 'Company is required',
        DESCRIPTION: 'Description is required',
        RESPONSIBLE: 'Responsible is required',
        DUE_DATE: 'Due date is required',
      },
      DELETE_EVENT_SIMPLE: {
        TITLE: 'Delete action',
        DESCRIPTION: 'Are you sure you want to permanently delete this event?',
        WAIT_DESCRIPTION: 'Deleting...',
        MESSAGE: 'Action deleted successfully',
      },
      EDIT: {
        ADD_MESSAGE: 'Event created successfully',
        UPDATE_MESSAGE: 'Event updated successfully',
      },
    },
    EVENTACTION: {
      VIEWEVENTACTION: 'View',
      EVENTACTIONS: 'Action',
      NEW_EVENTACTION: 'Create Action',
      EDIT_EVENTACTION: 'Edit Action',
      ADDED: 'Action added successfully',
      UPDATED: 'Action updated successfully',
      INPUT: {
        ACTION_NAME: 'Name',
        COMPANY_ID: 'Company id',
        COMPANY_NAME: 'Company',
        DESCRIPTION: 'Description',
        STATUS: 'Status',
      },
      FORM: {
        NAME: 'Name is required',
        COMPANY: 'Company is required',
        DESCRIPTION: 'Description is required',
      },
      DELETE_EVENTACTION_SIMPLE: {
        TITLE: 'Delete action',
        DESCRIPTION: 'Are you sure you want to permanently delete this action?',
        WAIT_DESCRIPTION: 'Deleting...',
        MESSAGE: 'Action deleted successfully',
      },
      EDIT: {
        ADD_MESSAGE: 'Action created successfully',
        UPDATE_MESSAGE: 'Action updated successfully',
      },
      MAP: {
        SOURCE: 'Source',
        DESTINATION: 'Destination',
        MAPPING: 'Mapping',
      },
    },

    DIALOG: {
      DELETE_USER_MULTY: 'Delete selected users',
      ARE_YOU_SURE_TO_DELETE_SELECTED_USER:
        'Are you sure you want to permanently delete the selected users?',
      SELECTED_USERS_HAVE_BEEN_DELETED: 'Selected users have been deleted',
      ARE_YOU_SURE: 'Are you sure to do this?',
      DELETING: 'Deleting...',
      DELETING_USER: 'Deleting user ...',
      HAVE_BEEN_DELETED: 'have been deleted',
      UPDATE_STATUS_MULTY: 'Update selected users status',
      UPDATE_SINGLE_STATUS: 'Update user status',
      UPDATE_SINGLE_STATUS_DOCTOR: 'Update doctor status',
      UPDATE_SINGLE_STATUS_MEETING: 'Update meeting status',
      ARE_YOU_SURE_DELETE_DOCTOR: 'Are you sure you want to permanently delete this doctor?',
      ARE_YOU_SURE_DELETE_USER: 'Are you sure you want to permanently delete this user?',
      ARE_YOU_SURE_DELETE_AFFILIATION:
        'Are you sure you want to permanently delete this affiliation?',
      ARE_YOU_SURE_UPDATE_DOCTOR: '',
      ARE_YOU_SURE_TO_UPDATE_USER: 'Are you sure you want to change the user status?',
      UPDATING: 'Updating...',
      UPDATING_USER: 'Updating user...',
      HAVE_BEEN_UPDATED: 'have been updated',
      USER_HAVE_BEEN_UPDATED: 'User have been updated',
      USER_HAVE_BEEN_DELETED: 'User have been deleted',
      SAVE: 'Saved successfully ',
      DELETE_USER_SINGLE: 'Delete user',
      DELETE_AFF_SINGLE: 'Delete affiliation',
      DELETE_DOCTOR_SINGLE: 'Delete doctor',
      DELETE_MEETING_SINGLE: 'Delete meeting',
      RESET: 'Reset form',
      RESETING: 'Reset...',
      STATUS_HAVE_BEEN_UPDATED: 'User status have been updated ',
      ASSIGN: {
        LABEL: 'Assign',
        STANDARD: 'Standard/s',
        STANDARD_MESSAGE: 'Standard/s assignment updated successfully',
        RESOURCE: 'Resource/s',
        RESOURCE_MESSAGE: 'Resource/s assignment updated successfully',
        BLOCKER: 'Blocker/s',
        BLOCKER_MESSAGE: 'Blocker/s assignment updated successfully',
      },
    },
    PERMISSION: {
      LOGIN_DETAILS: 'Can View Login Details',
      EDIT_APPS: 'Can Edit Applications',
      SALES_TEAMS: 'Access to Sales Teams',
      COMMENTS: 'Comments',
      COMMENTS_EDIT: 'Edit',
      COMMENTS_DELETE: 'Delete',
      ACCESS_TAGS: 'Tags Feature',
      VIEW: 'View',
      ADD: 'Add',
      DELETE: 'Delete',
      ACCESS_AUTH_LOGS: 'Access Auth Logs',
      EDIT: 'Edit',
      ASSIGN: 'Assign',
      SOFT_DELETE: 'Delete',
      ACTIVATE: 'Activate',
      SHARE: 'Share',
      APPROVE: 'Approve',
      DENY: 'Deny',
      ACCESS_PATIENT_IMAGE_CHANGE: 'Patient Image Change Request',
      AGREEMENT: {
        ACCESS: 'Agreements',
        ACCESS_TEMPLATE: 'Agreement Templates',
        EDIT_OFFICE_CONFIG: 'Configuration',
        REVOKE: 'Revoke',
        REMIND: 'Remind',
      },
      ACCESS_ROLE: 'Role List',
      ACCESS_ROLE_TEMPLATES: 'Role Template List',
      ACCESS_OFFICE: 'Office List',
      ACCESS_COMPANY: 'Company List',
      ACCESS_USER: 'User List',
      ACCESS_CONTACT: 'Contact List',
      ACCESS_PATIENT: 'Patient List',
      ACCESS_DOCTOR: 'Doctor List',
      ACCESS_FACILITY: 'Facility List',
      ACCESS_AFFILIATION: 'Affiliation List',
      ACCESS_AFFILIATION_TYPE: 'Affiliation Type',
      TOGGLE_SUPERVISING_CONTROL: 'Toggle Supervising Control',
      ACCESS_ACTIVITY_LOG: 'Activity Log List',
      ACCESS_INSURANCE: 'Insurance List',
      ACCESS_DEVICE_TYPE: 'Device type List',
      ACCESS_DEVICE_INVENTORY: 'Device Inventory List',
      ACCESS_PROGRAM: 'Program List',
      ACCESS_PROGRAM_PARTICIPANT: 'Program Participant List',
      ACCESS_DEVICE: 'Device Module',
      ACCESS_DOCUMENT_LIBRARY: 'Document Library List',
      ACCESS_WORKFLOW_MENU: 'Workflow List',
      ADD_TAGS: 'Add Tag',
      CREATE_WORKFLOW_FROM_START: 'Can Create Workflow ',
      ACCESS_MEETING: 'Meeting List',
      NEW_MEETING: 'New Meeting',
      ACCESS_TO_SALE: 'Sale List',
      COMMUNICATION: 'Communication',
      SEND_EMAIL: 'Send Email',
      SEND_FAX: 'Send Fax',
      SEND_MESSAGE: 'Send Message',
      SEND_DOCUMENTS: 'Send Documents',
      SEND_NOTIFICATION: 'Send Notification',
      ACCESS_EVENT: 'Event List',
      ACCESS_WORKFLOW: 'Workflow List',
      ACCESS_WORKFLOW_GROUP: 'Workflow Group List',
      ACCESS_ACTION: 'Action List',
      ACCESS_API: 'API List',
      ACCESS_CALENDAR: 'Calendar',
      ACCESS_CHAT: 'Chat Agent App',
      ACCESS_DRUG_GROUP: 'Drug Group List',
      ACCESS_CLIENT: 'Client List',
      ACCESS_DRUG: 'Drug List',
      ACCESS_PHARMACY: 'Pharmacy List',
      ACCESS_PHARMACY_GROUP: 'Pharmacy Group List',
      ACCESS_PHARMACY_GROUP_DRUG: 'Pharmacy Group Drug List',
      ACCESS_ALLERGY: 'Allergy',
      ACCESS_CONDITION: 'Condition',
      ACCESS_PRACTITIONER: 'Practitioner Role',
      ACCESS_PRACTITION_ROLE: 'Practitioner Role',
      ACCESS_INBOX: 'Inbox',
      ACCESS_IMMUNIZATION: 'Immunization',
      ACCESS_CATEGORY: 'Category List',
      ACCESS_TEAM: 'Teams List',
      ADD_NOTE: 'Add Notes',
      SEARCH_GENERAL: 'General search',
      REASSIGN_TASK: 'Reassign Tasks',
      VIEW_USER_TASKS: "View Other Users' Tasks",
      ACCESS_EVENT_LEGACIES: 'legacy workflows',
      ACCESS_TEMPLATE: 'Template',
      ACCESS_TO_TASK: 'Tasks Feature',
      VIEW_CALENDER: 'View Calendar',
      ACCESS_AID_BOX: 'AidBox Feature',
      ACCESS_NOTE: 'Notes Feature',
      ACCESS_RELATION: 'Relations Feature',
      ACCESS_TAG_COMMUNICATION: 'Access Communication Tags',
      ACCESS_WORKFLOW_FEATURE: 'Workflow Feature',
      GENERAL: 'General',
      ASSIGN_PATIENT: 'Assign Patient',
      ACCESS_ANALYSIS: 'Analytics Feature',
      ANALYSIS_VIEW: 'Analytics View',
      ACCESS_ANALYTICS: 'Access to Analytics Builder',
      BUILDER_KNOSTOS: 'Analytics Knostos Builder',
      BUILDER_PRIVATE: 'Analytics Private Builder',
      MERGE: 'Merge Contacts',
      ACCESS_LINKS: 'Links Feature',
      ACCESS_FILTERED_VIEW: 'Filter View',
      ACCESS_COMMUNICATION: 'Access Communication',
      ACCESS_FAX: 'Access Fax',
      ACCESS_MANUAL_UPLOAD: 'Access Manual Upload',
      ACCESS_MED_REVIEW: 'Access Med Review',
      ACCESS_APPLICATION: 'Access Applications',
      COMPLIANCE: {
        ACCESS_AGENCIES: 'Access Compliance Agencies',
        ACCESS_PROGRAMS: 'Access Compliance Programs',
        ACCESS_STANDARDS: 'Access Compliance Standards',
        ACCESS_REPORTING: 'Access Compliance Reporting',
      },
      ACCESS_CONTEXTUAL_HISTORY: 'Access Contextual History',
      CANCEL_TASK: 'Cancel Task',
      CONTACT_RELATIONSHIP: 'Access Lookup Lists',
      CATEGORY_DESCRIPTION: 'Access Category Description',
      RELATIONSHIP_CATEGORY: 'Access Relationship Category',
      REASON_DRP: 'Access Reason DRP',
      REASON_FOLLOWUP: 'Access Reason Follow-up',
      OTHER_RECENT: 'Access Other Recent Accessed Entities',
      SALES_CALLS: 'Access to Sales Calls',
      EDIT_COMPLETED: 'Edit sales calls that are already completed',
      EDIT_OTHER_RESPONSIBLES: 'Edit sales calls that are responsibility of other team members',
      RECEIVED_DOCUMENT: 'Access Received Document',
      ACCESS_ANALYTICS_LIST: 'Analytics Access',
      ACCESS_PAGE_GROUP_LIST: 'Page Group',
      ACCESS_EXTERNAL_LIST: 'External Access',
      ACCESS_INTERNAL_LIST: 'Internal Access',
      WEBHOOK: 'Webhooks',
      WEBHOOK_CREDENTIAL: 'Credential list',
      WEBHOOK_ACTIVE: 'Active Webhook list',
      ACCESS_DICTIONARIES: 'Access Dictionaries',
      ACCESS_CONCEPTS: 'Access Knostos Concepts',
      ACCESS_SYNONYMS: 'Access Synonyms',
      ACCESS_FORMS: 'Access Forms',
      ACCESS_DOCUMENT_TEMPLATES: 'Access Document Templates',
      ACCESS_FORM_TEMPLATE_MAPPING: 'Access Form-Template Mapping',
      'FORM.AGENT.ACCESS': 'Access Form AI Agent',
      IMPORT_GLOBAL_FORM: 'Import Global Form',
      ACCESS_DOCUMENT_CATEGORY: 'Access Documents Categories',
      ACCESS_DOCUMENT: 'Access Documents Library',
      VIEW_ACCESS_HISTORY: 'View Access History',
      ACCESS_ACTIVITY_TEMPLATES: 'Access Activity Templates',
      ACCESS_ACTIVITIES: 'Access Activities',
      CAN_IMPERSONATE: 'Impersonate Team/Role',
      ACCESS_STATEMENTS_MAPPING: 'Access Statements Templates Mapping',
      ACCESS_STATEMENTS_DASHBOARD: 'Access Statements Dashboard',
      ACCESS_STATEMENTS_REVIEW: 'Access Statements Review',
      VALIDATE_ADDRESS: 'Validate Address',
      ACCESS_STATEMENTS_SETTINGS: 'Access Statements Collections Settings',
      BRIDGE_PAY: {
        ACCESS: 'Access to bridgePay ',
        VIEW_TRANSACTIONS: 'View transaction history',
      },
      PAYMENT_METHOD: {
        VIEW: 'Access payment methods',
        ADD: 'Add payment method',
        ADD_CREDIT: 'Add credit card',
        ADD_ACH_TRANSFER: 'Add ACH Bank account',
      },
      PAY_POINTS: {
        MANAGE: 'Manage payPoints',
      },
      PAYMENT: {
        PROCESS: 'Can process payment',
        SELECT_WALLET: 'Can select from wallet',
        USE_CREDIT: 'Can use credit card',
        USE_ACH_TRANSFER: 'Can use ACH TRANSFER',
      },
      ENROLLMENT: {
        ACCESS: 'Enrollment Verification List',
        VIEW: 'View Enrollment Verification Details',
        VIEW_HISTORY: 'View History',
        EDIT_STATUS: 'Edit Status',
      },
    },

    CONNECTION: {
      TOO_MANY_CONN: 'Too many connections',
    },
    APLOS_EMAIL: {
      WELCOME: 'A Big welcome to Knostos family',
      DEAR: 'Dear',
      THANKS: 'Thanks for using Knostos application',
    },
    RESET_PASSWORD: {
      EMAIL_BODY:
        'We heard that you lost your password.Sorry about that! \n But don’t worry! You can use the below link to reset your password, \n if you don’t use this link within 1 hour, it will expire',
      BUTTON: 'Click to reset password',
    },
    ASSIGN_USER_ROLE: {
      USER_TYPE: "You can't create user without select a role for him",
      ADMIN_TYPE: "You can't create Admin without select a  company  for him",
    },
    FACILITY: {
      FILTER_BY: 'Filter By ',
      DEMOGRAPHICS: 'Facility Details',
      NAME: 'Name',
      NAME_EMAIL: 'Name/Email',
      FACILITY_CODE: 'Facility Code',
      FACILITY_NAME: 'Facility Name',
      FACILITY_TYPE: 'Facility Type',
      CONTACT_NAME: 'Contact Name',
      CONTACTS: 'Contact/s',
      FACILITY_EMAIL: 'Facility Email',
      FACILITY_PHONE: 'Facility Phone',
      NPI: 'NPI',
      NOTE: 'Note',
      DAY_SUPPLY: 'Day Supply',
      OTHER_DETAILS: 'Other Details',
      BY_ROBOT: 'By Robot',
      FILLED_BY_ROBOT: 'Filled by Robot',
      FILL_BY_ROBOT: 'Fill By Robot',
      FILL_UPTO: 'Fill Upto',
      CYCLE_FILL: 'Cycle Fill',
      LEAD_DAYS: 'Lead Days',
      LEAD_DAYS_TO_FILL: 'Lead Days To Bill',
      LEAD_DAYS_TO_DELIVARY: 'Lead Days To Delivery',
      CONTACTS_AND_ADDRESS: 'Address Details',
      CITY: 'City',
      STATE: 'State',
      ZIP: 'ZIP',
      ADDRESS_1: 'Address 1',
      ADDRESS_2: 'Address 2',
      PHONE: 'Phone',
      FAX: 'Fax',
      EMAIL: 'Email',
      CODE: 'Code',
      TYPE: 'Type',
      STATUS: 'Status',
      EDIT_FACILITY: 'Edit Facility',
      VIEW_FACILITY: 'View Facility',
      REQUIREDPHONE: 'Phone is Required',
      REQUIRED_FAX: 'Fax is Required',
      FACILITY: 'Facility',
      FACILITIES_LIST: 'Facilities List',
      ADD_FACILITY: 'Add Facility',
      NEW_FACILITY: 'New Facility',
      LOCATION: 'Loaction',
      PROCESSED: 'Processed',
      PACKING: 'Packing_id',
      ADDED: 'Facility Successful Added',
      UPDATED: 'Facility Successful Updated',
      DELETE_FACILITY_SIMPLE: {
        TITLE: 'Facility Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this facility?',
        WAIT_DESCRIPTION: 'Facility is deleting...',
        MESSAGE: 'Facility has been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Facility Status Update',
        DESCRIPTION: 'Are you sure you want to change the facility status?',
        WAIT_DESCRIPTION: 'Facility status is updating...',
        MESSAGE: 'Facility status has successfully been updated',
      },
    },
    EMAIL_FAX: {
      COMPOSE: 'Compose',
      EMAIL: 'Email',
      FAX: 'Fax',
      TO: 'To',
      SUBJECT: 'Subject',
      BODY: 'Body',
      ATTACHMENTS: 'Attachments',
      SEND: 'Send',
      SUCCESS: 'Successfully Sent',
      UPLOAD_ERROR: 'There was a problem with the following files:',
      ATTACHMENT_MODE: 'Attachment Mode',
      UPLOAD_FILES: 'Upload Files',
      SELECT_DOCS: 'Select Documents',
      SEARCH_TOPIC: 'Search Topic',
      DOCUMENT: 'Document',
      RELATED_TO: 'Related To',
    },
    TASK: {
      PRIORITY: 'Priority',
      TITLE: 'Title',
      PROCESS_NAVIGATOR: 'Process Navigator',
      TEAM: 'Team',
      STATUS: 'Status',
      FOR: 'for',
      BLOCKERS: 'Blockers',
      ASSIGN_USER: 'Assign User',
      ASSIGNEE: 'Assignee',
      ADD_FOLLOWER: 'Add Follower',
      FOLLOWER: 'Follower',
      ASSIGN_ENTITIES: 'Assign Entities',
      ENTITY_TYPE: 'Entity Type',
      ENTITIES: 'Entities',
      DUE_DATE: 'Due Date',
      DUE: 'Due',
      DUE_TOMORROW: 'Due Tomorrow',
      DUE_TODAY: 'Due Today',
      OVERDUE: 'Overdue',
      OFFICE: 'Office',
      DESCRIPTION: 'Description',
      URL_RESOURCE: 'URL Resource',
      ATTACHMENTS: 'Attachments',
      ADD_ATTACHMENTS: 'Add Attachments',
      SHARE_ATTACHMENT: {
        TITLE: 'Share Task Attachments',
        SUBJECT: 'Subject',
        ATTACHMENTS: 'Attachments',
        METHODS: 'Methods',
        TO: 'To',
        MESSAGE: 'Attachment/s shared successfully',
      },
      SHARE: 'Share',
      FOLLOW_UP: 'Follow Up',
      CREATE_TASK: 'Create Task',
      CREATE_RELATED_TASK: 'Create Related Task',
      RELATED_TEMPLATE: 'Related Template',
      COMMENTS: 'Comments',
      ADD_TAGS: 'Add Tags',
      TAGS: 'Tags',
      CREATED: 'Created',
      TASK_ID: 'Task ID',
      TEMPLATE_ID: 'Template ID',
      VIEW: 'View',
      INTERVENTION: {
        CATEGORY: 'Category',
        SOURCE: 'Source',
        PCNE_CODE: 'PCNE Code',
        LEVEL: 'Level',
        DRP_TITLE: 'DRP Title',
        DRP_TEXT: 'DRP Text',
        CAUSES: 'Causes',
        INTERVENTION_NOTE: 'Intervention Note',
        INTERVENTION_ACCEPTANCE: 'Intervention Acceptance',
        OUTCOME: 'Outcome',
        OUTCOME_NOTE: 'Outcome Note',
      },
      CHECKLIST: {
        COMPLETED_BY: 'Completed by',
        COMPLETED_AT: 'Completed at',
      },
      VALIDATION: {
        INVALID: 'Invalid {{label}}',
        REQUIRED: '{{label}} field is required',
      },
      CREATED_MESSAGE: 'Task created successfully',
      UPDATED_MESSAGE: 'Task updated successfully',
      CREATED_WITH_ATTACHMENT_ERROR_MESSAGE:
        'Task created successfully. But something went wrong in uploading attachments!',
      UPDATED_WITH_ATTACHMENT_ERROR_MESSAGE:
        'Task updated successfully. But something went wrong in uploading attachments!',
      SET_PRIORITY: 'Set Priority',
      HIGH: 'High',
      MEDIUM: 'Medium',
      LOW: 'Low',
      CANCEL_REASON: 'Please enter the reason for cancellation below:',
      CANCEL_PROMPT: 'Are you sure you want to cancel this task?',
    },
    TABS: {
      NOTES: 'Notes',
      ALLERGIES: 'Allergies',
      CONDITIONS: 'Conditions',
      IMMUNIZATIONS: 'Immunizations',
      DEVICES: 'Devices',
      PRESCRIPTIONS: 'Prescriptions',
    },

    IMMUNIZATION: {
      IMMUNIZATION_LIST: 'Immunization List',
      NEW_IMMUNIZATION: 'New Immunization',
      EDIT_IMMUNIZATION: 'Edit Immunization',
      VIEW_IMMUNIZATION: 'View Immunization',
      IMMUNIZATION_INFO: 'Immunization info',
      EDIT: {
        ADD_MESSAGE: 'Immunization created successfully',
        UPDATE_MESSAGE: 'Immunization updated successfully',
      },
      INPUT: {
        BASIC: 'Basic',
        EDUCATION: 'Education',
        PROTOCOL_APPLIED: 'Protocol applied',
        PERFORMER: 'Performer',
        OTHER: 'Other',
        STATUS: 'Status',
        STATUS_REASON: 'Status reason',
        VACCINE_CODE: 'Vaccine code',
        OCCURRENCE: 'Occurrence date',
        RECORDED_DATE: 'Recorded date',
        PRIMARY_SOURCE: 'Primary source',
        REPORT_ORIGIN: 'Report origin',
        LOT_NUMBER: 'Lot number',
        EXPIRATION_DATE: 'Expiration date',
        SITE: 'Site',
        ROUTE: 'Route',
        DOSE_QUANT_VALUE: 'Dose quantity(value)',
        DOSE_QUANT_UNIT: 'Dose quantity(unit)',
        FUNCTION: 'Function',
        ACTOR_TYPE: 'Actor type',
        ACTOR: 'Actor',
        NOTE: 'Note',
        REASON_CODE: 'Reason code',
        IS_SUBPOTENT: 'Is subpotent',
        SUBPOTENTREASON: 'Subpontent reason',
        DOC_TYPE: 'Document type',
        REFERENCE: 'Reference',
        PUBLICATION_DATE: 'Publication date',
        PRESENTATION_DATE: 'Presentation date',
        PROGRAM_ELIGIBILITY: 'Program eligibility',
        FUNDING_SOURCE: 'Funding source',
        TARGET_DISEASE: 'Target disease',
        DOSE_NUMBER: 'Dose number',
        SERIESDOSES: 'Series doses',
        SERIES: 'Series',
        CONDITION: 'Condition',
      },
      DELETE_IMMUNIZATION_SIMPLE: {
        TITLE: 'Immunization Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this immunization?',
        WAIT_DESCRIPTION: 'Immunization is deleting...',
        MESSAGE: 'Immunization has been deleted',
      },
    },
    ALLERGY: {
      ALLERGY_LIST: 'Allergy List',
      NEW_ALLERGY: 'New Allergy',
      EDIT_ALLERGY: 'Edit Allergy',
      VIEW_ALLERGY: 'View Allergy',
      ALLERGY_INFO: 'Allergy info',
      EDIT: {
        ADD_MESSAGE: 'Allergy created successfully',
        UPDATE_MESSAGE: 'Allergy updated successfully',
      },
      INPUT: {
        CODE: 'Code',
        CLINICAL_STATUS: 'Clinical status',
        VERIFICATION_STATUS: 'Verification status',
        RECORDED_DATE: 'Recorded date',
        LAST_OCCURRENCE: 'Last occurrence',
        NOTE: 'Note',
        TYPE: 'Type',
        CRITICALITY: 'Criticality',
        CATEGORY: 'Category',
        SUBSTANCE: 'Substance',
        MANIFESTATION: 'Manifestation',
        DESCRIPTION: 'Description',
        ONSET: 'Onset date',
        SEVERITY: 'Severity',
        EXPOSUREROUTE: 'Exposure route',
        RECORDER_TYPE: 'Recorder type',
        RECORDER: 'Recorder',
        ONSET_TYPE: 'Onset input type',
        ONSET_DATE: 'Onset(date)',
        ONSET_STRING: 'Onset(text)',
        ONSET_PERIOD_START: 'Onset(From)',
        ONSET_PERIOD_END: 'Onset(To)',
        ONSET_AGE: 'Onset(Age)',
        ONSET_AGE_UNIT: 'Age unit',
        ONSET_RANGE_LOW: 'Range(low)',
        ONSET_RANGE_HIGH: 'Range(high)',
        ASSERTER_TYPE: 'Asserter type',
        ASSERTER: 'Asserter',
        BASIC: 'Basic',
        ON_SET: 'Onset',
        RECORDING: 'Recording',
        REACTION: 'Reaction',
      },
      DELETE_ALLERGY_SIMPLE: {
        TITLE: 'Allergy Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this allergy?',
        WAIT_DESCRIPTION: 'Allergy is deleting...',
        MESSAGE: 'Allergy has been deleted',
      },
    },
    CONDITION: {
      CONDITIONS_LIST: 'Condition List',
      NEW_CONDITION: 'New Condition',
      EDIT_CONDITION: 'Edit Condition',
      VIEW_CONDITION: 'View Condition',
      CONDITION_INFO: 'Condition info',
      EDIT: {
        ADD_MESSAGE: 'Condition created successfully',
        UPDATE_MESSAGE: 'Condition updated successfully',
      },
      INPUT: {
        CODE: 'Code',
        CLINICAL_STATUS: 'Clinical status',
        VERIFICATION_STATUS: 'Verification status',
        RECORDED_DATE: 'Recorded date',
        LAST_OCCURRENCE: 'Last occurrence',
        NOTE: 'Note',
        TYPE: 'Type',
        CRITICALITY: 'Criticality',
        CATEGORY: 'Category',
        SUMMARY: 'Summary',
        EVIDENCE: 'Evidence',
        DESCRIPTION: 'Description',
        ONSET: 'Onset date',
        SEVERITY: 'Severity',
        BODYSITE: 'Body Site',
        RECORDER_TYPE: 'Recorder type',
        RECORDER: 'Recorder',
        ONSET_TYPE: 'Onset input type',
        ONSET_DATE: 'Onset(date)',
        ONSET_STRING: 'Onset(text)',
        ONSET_PERIOD_START: 'Onset(From)',
        ONSET_PERIOD_END: 'Onset(To)',
        ONSET_AGE: 'Onset(Age)',
        ONSET_AGE_UNIT: 'Age unit',
        ONSET_RANGE_LOW: 'Range(low)',
        ONSET_RANGE_HIGH: 'Range(high)',
        ABATEMENT: 'Abatement',
        ABATEMENT_TYPE: 'Abatement input type',
        ABATEMENT_DATE: 'Abatement(date)',
        ABATEMENT_STRING: 'Abatement(text)',
        ABATEMENT_PERIOD_START: 'Abatement(From)',
        ABATEMENT_PERIOD_END: 'Abatement(To)',
        ABATEMENT_AGE: 'Abatement(Age)',
        ABATEMENT_AGE_UNIT: 'Age unit',
        ABATEMENT_RANGE_LOW: 'Range(low)',
        ABATEMENT_RANGE_HIGH: 'Range(high)',
        ASSERTER_TYPE: 'Asserter type',
        ASSERTER: 'Asserter',
        BASIC: 'Basic',
        ON_SET: 'Onset',
        RECORDING: 'Recording',
        REACTION: 'Reaction',
      },
      DELETE_CONDITION_SIMPLE: {
        TITLE: 'Condition Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this condition?',
        WAIT_DESCRIPTION: 'Condition is deleting...',
        MESSAGE: 'Condition has been deleted',
      },
    },
    DRUG_GROUP: {
      DRUG_GROUP: 'Drug Group',
      DRUG_GROUPS: 'Drug Groups',
      DRUG_GROUPS_LIST: 'Drug Group list',
      NEW_DRUG_GROUP: 'New Drug Group',
      EDIT_DRUG_GROUP: 'Edit Drug Group',
      VIEW_DRUG_GROUP: 'View Drug Group',
      UPDATED: 'Drug Group Successfully Updated',
      STATUS_UPDATED: 'Drug Group Status Successfully Updated',
      DELETED: 'Drug Group Successfully Deleted',
      NAME_LENGTH: 'Invalid name! Drug Group name must be at least 2 characters long',
      DELETE_DRUG_GROUP_SIMPLE: {
        TITLE: 'Drug Group Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this drug group?',
        WAIT_DESCRIPTION: 'Drug Group is deleting...',
        MESSAGE: 'Drug Group has been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Drug Group Status Update',
        DESCRIPTION: "Are you sure you want to change the Drug Group's status?",
        WAIT_DESCRIPTION: 'Drug Group status is updating...',
        MESSAGE: 'Drug Group status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Drug Group has been updated',
        ADD_MESSAGE: 'Drug Group has been created',
      },
      TABLE: {
        STATUS: 'Status',
        NAME: 'Name',
      },
      FORM: {
        NAME: 'Name',
        COPAY_ASSISTANCE: 'Copay Assistance',
        COPAY_ASSISTANCE_URL: 'Copay Assistance URL',
        DRUG_GROUP_STATUS: 'Drug Group Status',
        DRUG_GROUP_DETAILS: 'Drug Group Details',
        OTHER: 'Other',
        NOTE: 'Note',
      },
    },
    DRUG: {
      DRUG: 'Drug',
      DRUGS: 'Drugs',
      DRUGS_LIST: 'Drug list',
      NEW_DRUG: 'New Drug',
      EDIT_DRUG: 'Edit Drug',
      VIEW_DRUG: 'View Drug',
      UPDATED: 'Drug Successfully Updated',
      STATUS_UPDATED: 'Drug Status Successfully Updated',
      DELETED: 'Drug Successfully Deleted',
      NAME_LENGTH: 'Invalid name! Drug name must be at least 2 characters long',
      DELETE_DRUG_SIMPLE: {
        TITLE: 'Drug Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this drug?',
        WAIT_DESCRIPTION: 'Drug is deleting...',
        MESSAGE: 'Drug has been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Drug Status Update',
        DESCRIPTION: "Are you sure you want to change the Drug's status?",
        WAIT_DESCRIPTION: 'Drug status is updating...',
        MESSAGE: 'Drug status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Drug has been updated',
        ADD_MESSAGE: 'Drug has been created',
      },
      TABLE: {
        DRUG: 'Drug',
        NDC: 'NDC',
        STRENGTH: 'Strength',
        FORM: 'Form',
        TH_CLASS: 'Therapeutic Class',
        JCODE: 'J-Code',
        STATUS: 'Status',
      },
      FORM: {
        MANUFACTURER: 'Manufacturer',
        FORM: 'Form',
        DRUG_DETAILS: 'Drug Details',
        DRUG: 'Drug',
        DRUG_GROUP: 'Drug Group',
        STRENGTH: 'Strength',
        RX: 'Rx',
        UNIT: 'Unit',
        NDC: 'NDC',
        BRAND_GENERIC_FLAG: 'Generic Brand',
        BRAND: 'Brand',
        GENERIC: 'Generic',
        TH_CLASS: 'Therapeutic Class',
        CFI: 'CFI',
        DRUG_SCHEDULE: 'Drug Schedule',
        OTC_FLAG: 'OTC Flag',
        UPC_CODE: 'UPC Code',
        PROCESSED: 'Processed',
        HICL_SEQNO: 'HICL Seq No',
        PACK_SIZE: 'Pack Size',
        JCODE: 'J-Code',
        GPI: 'GPI',
        DDID: 'DDID',
        NOTE: 'Note',
        STATUS: 'Status',
        OTHER: 'Other',
        IDS: 'Identifiers',
        RXCUI: 'RXCUI',
      },
    },
    PHARMACY_GROUP: {
      PHARMACY_GROUP: 'Pharmacy Group',
      PHARMACY_GROUPS: 'Pharmacy Groups',
      PHARMACY_GROUPS_LIST: 'Pharmacy Group list',
      NEW_PHARMACY_GROUP: 'New Pharmacy Group',
      EDIT_PHARMACY_GROUP: 'Edit Pharmacy Group',
      VIEW_PHARMACY_GROUP: 'View Pharmacy Group',
      UPDATED: 'Pharmacy Group Successfully Updated',
      STATUS_UPDATED: 'Pharmacy Group Status Successfully Updated',
      DELETED: 'Pharmacy Group Successfully Deleted',
      NAME_LENGTH: 'Invalid name! Pharmacy Group name must be at least 2 characters long',
      DELETE_PHARMACY_GROUP_SIMPLE: {
        TITLE: 'Pharmacy Group Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this pharmacy group?',
        WAIT_DESCRIPTION: 'Pharmacy Group is deleting...',
        MESSAGE: 'Pharmacy Group has been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Pharmacy Group Status Update',
        DESCRIPTION: "Are you sure you want to change the Pharmacy Group's status?",
        WAIT_DESCRIPTION: 'Pharmacy Group status is updating...',
        MESSAGE: 'Pharmacy Group status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Pharmacy Group has been updated',
        ADD_MESSAGE: 'Pharmacy Group has been created',
      },
      TABLE: {
        STATUS: 'Status',
        NAME: 'Name',
        EMAIL: 'Email',
        PHONE: 'Phone',
        FAX: 'Fax',
      },
      FORM: {
        NAME: 'Name',
        BASIC_INFO: 'General Info',
        CONTACT_DETAILS: 'Contact Details',
        EMAIL: 'Email',
        PHONE: 'Phone',
        FAX: 'Fax',
        PREFERRED_COMMUNICATION_METHOD: 'Preferred Communication Method',
        ADDRESS: 'Address',
        STATE: 'State',
        CITY: 'City',
        ZIP: 'Zip',
        ADDRESS1: 'Address 1',
        ADDRESS2: 'Address 2',
        PHARMACY_GROUP_STATUS: 'Pharmacy Group Status',
        OTHER: 'Other',
        NOTE: 'Note',
      },
    },
    PHARMACY_GROUP_DRUG: {
      ADD_PHARMACY_GROUP_DRUGS: 'Add Drugs',
      PHARMACY_GROUP_DRUG: 'Pharmacy Group Drug',
      PHARMACY_GROUP_DRUGS: 'Pharmacy Group Drugs',
      PHARMACY_GROUP_DRUGS_LIST: 'Drug list',
      NEW_PHARMACY_GROUP_DRUG: 'Add Drugs',
      EDIT_PHARMACY_GROUP_DRUG: 'Edit Drug',
      UPDATED: 'Pharmacy Group Drug Successfully Updated',
      STATUS_UPDATED: 'Pharmacy Group Drug Status Successfully Updated',
      DELETED: 'Pharmacy Group Drug Successfully Deleted',
      NAME_LENGTH: 'Invalid name! Pharmacy Group Drug name must be at least 2 characters long',
      DELETE_PHARMACY_GROUP_DRUG_SIMPLE: {
        TITLE: 'Drug Remove',
        DESCRIPTION: 'Are you sure you want to permanently remove this drug?',
        WAIT_DESCRIPTION: 'Removing Drug...',
        MESSAGE: 'Drug has been removed',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Drug Status Update',
        DESCRIPTION: "Are you sure you want to change the Drug's status?",
        WAIT_DESCRIPTION: 'Drug status is updating...',
        MESSAGE: 'Drug status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Drug has been updated',
        ADD_MESSAGE: 'Drugs have been added',
      },
      TABLE: {
        STATUS: 'Status',
        NAME: 'Name',
        NDC: 'NDC',
        PRICE: 'Price',
        DESCRIPTION: 'Description',
      },
      FORM: {
        PRICE: 'Price',
        DESCRIPTION: 'Description',
        SEARCH_DRUGS: 'Search Drugs',
      },
    },
    PHARMACY: {
      PHARMACY: 'Pharmacy',
      PHARMACIES: 'Pharmacies',
      PHARMACIES_LIST: 'Pharmacy list',
      NEW_PHARMACY: 'New Pharmacy',
      EDIT_PHARMACY: 'Edit Pharmacy',
      VIEW_PHARMACY: 'View Pharmacy',
      UPDATED: 'Pharmacy Successfully Updated',
      STATUS_UPDATED: 'Pharmacy Status Successfully Updated',
      DELETED: 'Pharmacy Successfully Deleted',
      NAME_LENGTH: 'Invalid name! Pharmacy name must be at least 2 characters long',
      DELETE_PHARMACY_SIMPLE: {
        TITLE: 'Pharmacy Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this pharmacy?',
        WAIT_DESCRIPTION: 'Pharmacy is deleting...',
        MESSAGE: 'Pharmacy has been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Pharmacy Status Update',
        DESCRIPTION: "Are you sure you want to change the Pharmacy's status?",
        WAIT_DESCRIPTION: 'Pharmacy status is updating...',
        MESSAGE: 'Pharmacy status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Pharmacy has been updated',
        ADD_MESSAGE: 'Pharmacy has been created',
      },
      TABLE: {
        STATUS: 'Status',
        NAME: 'Name',
        EMAIL: 'Email',
        PHONE: 'Phone',
        FAX: 'Fax',
      },
      FORM: {
        NAME: 'Name',
        BASIC_INFO: 'General Info',
        PHARMACY_DETAILS: 'Pharmacy Details',
        NPI: 'NPI',
        DEA: 'DEA',
        REFERRAL_INFO: 'Referral Info',
        PHARMACY_GROUP: 'Pharmacy Group',
        CONTACT_DETAILS: 'Contact Details',
        EMAIL: 'Email',
        PHONE: 'Phone',
        FAX: 'Fax',
        PREFERRED_COMMUNICATION_METHOD: 'Preferred Communication Method',
        ADDRESS: 'Address',
        STATE: 'State',
        CITY: 'City',
        ZIP: 'Zip',
        ADDRESS1: 'Address 1',
        ADDRESS2: 'Address 2',
        PHARMACY_STATUS: 'Pharmacy Status',
        OTHER: 'Other',
        NOTE: 'Note',
      },
    },
    CLIENT: {
      CLIENT: 'Client',
      CLIENTS: 'Clients',
      CLIENTS_LIST: 'Client list',
      NEW_CLIENT: 'New Client',
      EDIT_CLIENT: 'Edit Client',
      VIEW_CLIENT: 'View Client',
      UPDATED: 'Client Successfully Updated',
      STATUS_UPDATED: 'Client Status Successfully Updated',
      DELETED: 'Client Successfully Deleted',
      NAME_LENGTH: 'Invalid name! Client name must be at least 2 characters long',
      DELETE_CLIENT_SIMPLE: {
        TITLE: 'Client Delete',
        DESCRIPTION: 'Are you sure you want to permanently delete this client?',
        WAIT_DESCRIPTION: 'Client is deleting...',
        MESSAGE: 'Client has been deleted',
      },
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Client Status Update',
        DESCRIPTION: "Are you sure you want to change the Client's status?",
        WAIT_DESCRIPTION: 'Client status is updating...',
        MESSAGE: 'Client status has successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Client has been updated',
        ADD_MESSAGE: 'Client has been created',
      },
      TABLE: {
        STATUS: 'Status',
        NAME: 'Name',
        EMAIL: 'Email',
        CLASS: 'Class',
        PHONE: 'Phone',
        FAX: 'Fax',
        DOMAIN: 'Domain',
      },
      FORM: {
        NAME: 'Name',
        DOMAIN: 'Domain',
        BASIC_INFO: 'Basic Info',
        CLIENT_DETAILS: 'Details',
        ORDER_STATUS_UPDATE: 'Send Order Status Update',
        REMIND_ZERO_REFILL: 'Send No Refill Reminder',
        CONTACT_DETAILS: 'Contact Details',
        EMAIL: 'Email',
        CELL_PHONE: 'Cellphone',
        OFFICE_PHONE: 'Office Phone',
        FAX: 'Fax',
        PREFERRED_COMMUNICATION_METHOD: 'Preferred Communication Method',
        ADDRESS: 'Address',
        STATE: 'State',
        CITY: 'City',
        ZIP: 'Zip',
        ADDRESS1: 'Address 1',
        ADDRESS2: 'Address 2',
        CLIENT_STATUS: 'Active',
        OTHER: 'Other',
        NOTE: 'Note',
      },
    },
    PRESCRIPTION: {
      PRESCRIPTIONS: 'Prescriptions',
      PRESCRIPTIONS_LIST: 'Prescriptions List',
      ADD_PRESCRIPTION: 'Add Prescription',
      NEW_PRESCRIPTION: 'Create Prescription',
      EDIT_PRESCRIPTION: 'Edit Prescription',
      VIEW_PRESCRIPTION: 'View Prescription',
      TABLE: {
        DRUG: 'Drug',
        RX: 'Rx',
        DOCTOR: 'Doctor',
        DATE: 'Date',
        STATUS: 'Status',
        PRESCRIPTION_DATE: 'Prescription Date',
        LAST_FILLED_DATE: 'Last Filled Date',
        DAYS_SUPPLY: 'Days Supply',
        REFILL: 'Refill',
        HOLD: 'Hold',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Prescription has been updated',
        ADD_MESSAGE: 'Prescription has been created',
      },
      FORM: {
        DRUG: 'Drug',
        DOCTOR: 'Doctor',
        PRESCRIBE_DATE: 'Prescribe Date',
        STOP_DATE: 'Stop Date',
        EXPIRY_DATE: 'Expiry Date',
        DAYS_SUPPLY: 'Days Supply',
        QUANTITY: 'Quantity',
        REFILL: 'Refill',
        ICD10: 'ICD10',
        DIAGNOSIS_CODE: 'Diagnosis',
        SIG: 'Sig',
        NOTE: 'Note',
        LAST_FILLED: 'Last Filled Date',
        IS_HOLD: 'Hold',
        HOLD_REASON: 'Hold Reason',
      },
      DELETE_PRESCRIPTION_SIMPLE: {
        TITLE: 'Delete Prescription',
        DESCRIPTION: 'Are you sure you want to permanently delete this prescription?',
        WAIT_DESCRIPTION: 'Deleting...',
        MESSAGE: 'Prescription deleted successfully',
      },
    },
    PATIENT_DEVICE: {
      LIST_TITLE: 'Patient Device List',
      TABLE: {
        NAME: 'Name',
        SERIAL_ID: 'Serial ID',
        DATE_LAST_SYNC: 'Date Last Synced',
        LAST_BATTERY_VALUE: 'Last Battery Value',
        ALERTS: 'Alerts',
        VIEW: 'View',
      },
      VIEW_DEVICE: {
        DEVICE_DETAILS: 'Device Details',
        ALERT: 'Alert!',
        NO_ALERTS: 'No Alerts',
        PATIENT_RANGE: 'Patient Range',
        PATIENT_VITALS: {
          TITLE: 'Patient Vitals',
          ID: 'ID',
          CAPTURE_DATE: 'Capture Date',
          ALERT: 'Alert',
          VIEW: 'View',
          CLICK_VIEW: 'Click to View',
        },
      },
      VIEW_VITALS: 'View Patient Vitals',
    },
    ME: {
      TITLE: 'ME',
      PROGRAM: '',
      PROGRAM_LIST: 'Program list',
      DEVICES_LIST: 'Devices list',
      DEVICES_TYPE_LIST: 'Devices Type list',
      DEVICES_INVENTORY_LIST: 'Devices Inventory list',
    },
    DOC_LIB: {
      DOC_LIBS: 'Document Library',
      FILTER_BY: 'Filter By ',
      INPUT: {
        TOPIC: 'Topic',
        DESCRIPTION: 'Description',
        CATEGORY: 'Category',
      },
      EDIT: {
        ADD_MESSAGE: 'Document has been uploaded',
      },
    },
    SALE: {
      DOC_LIB: 'Document Library',
    },
    INBOX: {
      INBOX: 'Inbox',
      DATE: 'Date',
      FROM: 'From',
      TYPE: 'Type',
      MESSAGE: 'Message',
      FROM_DATE: 'From Date',
      TO_DATE: 'To Date',
      OPEN_WORKFLOW_DIALOG: 'Open Workflow Dialog',
      WORKFLOW_SUCCESS: 'Workflow Successfully Started',
      REPLY: 'Reply',
      REPLY_ALL: 'Reply to all',
      REPLY_SENT: 'Reply sent',
      DOMAIN: 'Domain',
    },
    NOTE: {
      NOTES_LIST: 'Notes List',
      ADD_NOTE: 'Add Note',
      PINNED: 'Pinned',
      ENTITIES: 'Entities',
      ENTITY: 'Entity',
      CONTACTS: 'Contacts',
      CONTACT: 'Contact',
      SUBJECT: 'Subject',
      DESCRIPTION: 'Description',
      STARTED: 'Started',
      TEAM_CATEGORY: 'Team/Category',
      PROVIDED_BY_CONTACT: 'Provided By Contact',
      PIN_NOTE: 'Pin Note',
      CREATE_TASK_FROM_NOTE: 'Create Task from Note',
      DATE: 'Date',
      PICK_DATE: 'Pick Date',
      CREATED_ON: 'Created On',
      CREATED_BY: 'Created By',
      UPDATED_ON: 'Updated On',
      UPDATED_BY: 'Updated By',
      UPDATED: 'Updated',
      CREATED: 'Created',
      FOLLOW_UP: 'Follow Up',
      CREATE_TASK: 'Create Task',
      CREATE_MESSAGE: 'Note created successfully',
      UPDATE_MESSAGE: 'Note updated successfully',
      PIN_MESSAGE: 'Note pinned successfully',
      UNPIN_MESSAGE: 'Note unpinned successfully',
      CREATE_TASK_MESSAGE: 'Task created successfully',
      EXPORT_CSV_MESSAGE: 'Exporting Notes...',
      CREATE_TITLE: 'Create Note',
      UPDATE_TITLE: 'Edit Note',
      ASSIGN_ENTITIES: 'Assign Entities',
      ENTITY_TYPE: 'Entity Type',
      VALIDATION: {
        REQUIRED: '{{label}} field is required',
      },
    },
    CATEGORY: {
      CATEGORIES_LIST: 'Category List',
      NEW_CATEGORY: 'New Category',
      TABLE: {
        ID: 'ID',
        NAME: 'Name',
        EMAIL: 'Email',
      },
      ADD_SUCCESS: 'Successfully Added',
      UPDATE_SUCCESS: 'Successfully Updated',
      UPDATE_STATUS_SIMPLE: {
        TITLE: 'Category Status Update',
        DESCRIPTION: "Are you sure you want to change the Category's status?",
        WAIT_DESCRIPTION: 'Category status is updating...',
        MESSAGE: 'Category status has successfully been updated',
      },
      FORM: {
        NAME: 'Name',
        NAME_REQUIRED: 'Name is required',
      },
      EDIT_CATEGORY: 'Edit',
      ADD_CATEGORY: 'New',
    },
    LINK: {
      LINKS_LIST: 'Link List',
      NEW_LINK: 'New Link',
      TABLE: {
        NAME: 'Name',
        URL: 'URL',
      },
      ADD_SUCCESS: 'Link Successfully Added',
      UPDATE_SUCCESS: 'Link Successfully Updated',
      DELETE_SUCCESS: 'Link Successfully Deleted',
      DELETE_LINK_SIMPLE: {
        TITLE: 'Delete Link',
        DESCRIPTION: 'Are you sure you want to permanently remove this link?',
        WAIT_DESCRIPTION: 'Removing Link...',
      },
      FORM: {
        NAME: 'Name',
        NAME_REQUIRED: 'Name field is required',
        URL: 'URL',
        URL_REQUIRED: 'URL field is required',
        TYPE: 'Type',
        TYPE_REQUIRED: 'Type field is required',
        VALUE: 'Value',
        VALUE_REQUIRED: 'Value field is required',
      },
      EDIT_LINK: 'Edit',
      ADD_LINK: 'Add',
    },
    QRVEY: {
      ANALYTICS: 'Analytics',
      KNOSTOS_DATA: 'Knostos Data',
      YOUR_DATA: 'Your Data',
      PAGE_BUILDER: 'Page Builder',
      COMMON_PAGE_BUILDER: 'Common Page Builder',
      DATASET_BUILDER: 'Dataset Builder',
      REPORT_BUILDER: 'Report Builder',
      COMMON_REPORT_BUILDER: 'Common Report Builder',
    },
    REVIEW_OPEN: 'Review Open',
    TIME: 'Time',
    ACTIONS: 'Actions',
    DONE_DATE: 'Done Date',
    CYCLE_DATE: 'Cycle Date',
    MRS: 'MRS',
    COMPLETED: 'Completed',
    INDICATORS: 'Indicators',
    FACILITY_NAME: 'Facility Name',
    MED_REVIEW: {
      TITLE: 'MedReview',
      CONFIGS: 'MedReview Configs',
      RELATED_TASK_TEMPLATE: 'Related Task Template',
      ASSIGN_STANDARD: 'Assign Standard',
      ASSIGN_STANDARD_MESSAGE: 'Standard assignment updated successfully',
      UPDATE_CONFIGS_MESSAGE: 'MedReview Configs updated successfully',
      COMMENTS: 'Comments',
      FOLLOWUPS: 'Follow ups',
      SNAPSHOT: 'Snapshot',
    },
    NOTIFICATION: {
      DESCRIPTION: 'Description',
      COMPANY: 'Company',
      SOURCE: 'Source',
      SCOPE: 'Scope',
      TARGET: 'Target',
      NAME: 'Name',
      TEMPLATE: 'Template',
      TRIGGER: 'Trigger',
      CATEGORY: 'Category',
      CHANNELS: 'Channels',
      ADD_TITLE: 'Create Notification',
      UPDATE_TITLE: 'Update Notification',
      ADD_MESSAGE: 'Notification created successfully',
      UPDATE_MESSAGE: 'Notification updated successfully',
      DELETE: {
        TITLE: 'Delete Notification',
        DESCRIPTION: 'Are you sure you want to permanently delete this notification?',
        WAIT_DESCRIPTION: 'Deleting notification...',
        MESSAGE: 'Notification deleted successfully',
      },
    },
    COMPLIANCE: {
      FILTER_BY: 'Filter By ',
      AGENCY: {
        NAME: 'Name',
        TYPE: 'Type',
        ACTIVE: 'Active',
        ADD_TITLE: 'Create Agency',
        UPDATE_TITLE: 'Update Agency',
        ADD_MESSAGE: 'Agency created successfully',
        UPDATE_MESSAGE: 'Agency updated successfully',
        DELETE: {
          TITLE: 'Delete Agency',
          DESCRIPTION: 'Are you sure you want to permanently delete this agency?',
          WAIT_DESCRIPTION: 'Deleting agency...',
          MESSAGE: 'Agency deleted successfully',
        },
        UPDATE_STATUS: {
          TITLE: 'Update Agency Status',
          DESCRIPTION: 'Are you sure you want to change the status of this agency?',
          WAIT_DESCRIPTION: 'Updating agency status...',
          MESSAGE: 'Agency status updated successfully',
        },
      },
      STANDARD: {
        STANDARD_REFERENCE: 'Reference #',
        DESCRIPTION: 'Description',
        DOMAIN: 'Domain',
        ACTIVE: 'Active',
        ADD_TITLE: 'Create Standard',
        UPDATE_TITLE: 'Update Standard',
        ADD_MESSAGE: 'Standard created successfully',
        UPDATE_MESSAGE: 'Standard updated successfully',
        DELETE: {
          TITLE: 'Delete Standard',
          DESCRIPTION: 'Are you sure you want to permanently delete this standard?',
          WAIT_DESCRIPTION: 'Deleting standard...',
          MESSAGE: 'Standard deleted successfully',
        },
        UPDATE_STATUS: {
          TITLE: 'Update Standard Status',
          DESCRIPTION: 'Are you sure you want to change the status of this standard?',
          WAIT_DESCRIPTION: 'Updating standard status...',
          MESSAGE: 'Standard status updated successfully',
        },
      },
      PROGRAM: {
        LABEL: 'Program',
        NAME: 'Name',
        AGENCY: 'Agency',
        STANDARDS: 'Standards',
        ACTIVE: 'Active',
        ADD_TITLE: 'Create Program',
        UPDATE_TITLE: 'Update Program',
        MANAGE_STANDARDS_TITLE: 'Manage Program Standards',
        CREATE_STANDARD: 'Create New Standard',
        ASSIGN_STANDARDS: 'Assign Standard/s',
        ADD_MESSAGE: 'Program created successfully',
        UPDATE_MESSAGE: 'Program updated successfully',
        MANAGE_STANDARDS_MESSAGE: 'Program standards updated successfully',
        DELETE: {
          TITLE: 'Delete Program',
          DESCRIPTION: 'Are you sure you want to permanently delete this program?',
          WAIT_DESCRIPTION: 'Deleting program...',
          MESSAGE: 'Program deleted successfully',
        },
        UPDATE_STATUS: {
          TITLE: 'Update Program Status',
          DESCRIPTION: 'Are you sure you want to change the status of this program?',
          WAIT_DESCRIPTION: 'Updating program status...',
          MESSAGE: 'Program status updated successfully',
        },
      },
    },
    CONCEPTS_MODULE: {
      TITLES: {
        CONCEPTS_MANAGEMENT: 'Concepts Management',
        DICTIONARIES: 'Dictionaries',
        CONCEPTS: 'Knostos Concepts',
        SYNONYMS: 'Synonyms',
      },
      DICTIONARY: {
        DICTIONARIES_LIST: 'Dictionaries List',
        ADD_DICTIONARY: 'Add Dictionary',
        ID: 'ID',
        NAME: 'Name',
        CREATE_TITLE: 'Create Dictionary',
        UPDATE_TITLE: 'Update Dictionary',
        VIEW_TITLE: 'View Dictionary',
        CREATE_MESSAGE: 'Dictionary created successfully',
        UPDATE_MESSAGE: 'Dictionary updated successfully',
      },
      CONCEPT: {
        CONCEPTS_LIST: 'Knostos Concepts List',
        ADD_CONCEPT: 'Add Concept',
        ID: 'ID',
        CODE: 'Code',
        DESCRIPTION: 'Description',
        CREATE_TITLE: 'Create Concept',
        UPDATE_TITLE: 'Update Concept',
        VIEW_TITLE: 'View Concept',
        CREATE_MESSAGE: 'Concept created successfully',
        UPDATE_MESSAGE: 'Concept updated successfully',
      },
      SYNONYM: {
        SYNONYMS_LIST: 'Synonyms List',
        ADD_DICTIONARY: 'Add Dictionary',
        ADD_SYNONYM: 'Add Synonym',
        ID: 'ID',
        CODE: 'Code',
        DESCRIPTION: 'Description',
        DETAILED_DESCRIPTION: 'Detailed Description',
        DICTIONARY: 'Dictionary',
        CONCEPT: 'Knostos Concept',
        REVIEW: 'Review',
        STATUS: 'Status',
        REQUEST_TITLE: 'Request Synonym',
        CREATE_TITLE: 'Create Synonym',
        UPDATE_TITLE: 'Update Synonym',
        VIEW_TITLE: 'View Synonym',
        REVIEW_TITLE: 'Review Synonym',
        REQUEST_MESSAGE: 'Synonym requested successfully',
        CREATE_MESSAGE: 'Synonym created successfully',
        UPDATE_MESSAGE: 'Synonym updated successfully',
        REVIEW_MESSAGE: 'Reviewed! Synonym updated successfully',
        UPDATE_STATUS: {
          TITLE: 'Update Synonym Status',
          CAN_TOGGLE_DESCRIPTION: 'Are you sure you want to change the status of this synonym?',
          CANT_TOGGLE_DESCRIPTION: 'You are not permitted to change the status of this synonym!',
          WAIT_DESCRIPTION: 'Updating synonym status...',
          MESSAGE: 'Synonym status updated successfully',
        },
      },
      SYNONYM_VALUE: {
        SYNONYM_VALUES_LIST: 'Synonym Values List',
        ADD_SYNONYM_VALUE: 'Add Synonym Value',
        ID: 'ID',
        SERIAL: 'Serial',
        VALUE: 'Value',
        STATUS: 'Status',
        CREATE_TITLE: 'Create Synonym Value',
        UPDATE_TITLE: 'Update Synonym Value',
        VIEW_TITLE: 'View Synonym Value',
        CREATE_MESSAGE: 'Synonym Value created successfully',
        UPDATE_MESSAGE: 'Synonym Value updated successfully',
        UPDATE_STATUS: {
          TITLE: 'Update Synonym Value Status',
          DESCRIPTION: 'Are you sure you want to change the status of this synonym value?',
          WAIT_DESCRIPTION: 'Updating synonym value status...',
          MESSAGE: 'Synonym Value status updated successfully',
        },
      },
    },
    FORMS_TEMPLATES_MODULE: {
      TITLES: {
        FORMS_TEMPLATES: 'Forms & Templates',
        FORMS: 'Forms',
        DOCUMENT_TEMPLATES: 'Document Templates',
        FORM_TEMPLATE_MAPPING: 'Form-Template Mapping',
        FORM_AI_AGENT: 'Form AI Agent Beta',
        CUSTOM_MAPPING: 'Custom Mapping',
      },
      FORM: {
        FORMS_LIST: 'Forms List',
        ADD_FORM: 'Add Form',
        IMPORT_GLOBAL_FORM: 'Import Global Form',
        ID: 'ID',
        NAME: 'Name',
        TEAMS_CATEGORIES: 'Teams/Categories',
        TEAM_CATEGORY: 'Team/Category',
        SYSTEM: 'System',
        VERSION: 'Version',
        STATUS: 'Status',
        SCHEMA: {
          TITLE: 'Schema',
          FORM: 'Form',
          VERSION_0: 'Version 0',
          CREATE_TITLE: 'Create Schema',
          UPDATE_TITLE: 'Update Schema',
          VIEW_TITLE: 'View Schema',
        },
        LOOKUP: 'Lookup',
        CREATE_TITLE: 'Create Form',
        CREATE_FROM_GLOBAL_SUBTITLE: 'Create a Form by importing a Global Form',
        UPDATE_TITLE: 'Update Form',
        VIEW_TITLE: 'View Form',
        LINK_TITLE: 'Link Form Fields to Synonyms',
        CREATE_MESSAGE: 'Form created successfully',
        UPDATE_MESSAGE: 'Form updated successfully',
        UPDATE_STATUS: {
          TITLE: 'Update Form Status',
          WAIT_DESCRIPTION: 'Updating form status...',
          MESSAGE: 'Form status updated successfully',
        },
        LINK_MESSAGE: 'Linking form fields to synonyms/lookups updated successfully',
      },
      TEMPLATE: {
        TEMPLATES_LIST: 'Templates List',
        ADD_TEMPLATE: 'Add Template',
        ID: 'ID',
        NAME: 'Name',
        ORIGIN: 'Origin',
        STATUS: 'Status',
        FILE: 'File',
        KEYS: 'Keys',
        CREATE_TITLE: 'Create Template',
        UPDATE_TITLE: 'Update Template',
        VIEW_TITLE: 'View Template',
        CREATE_MESSAGE: 'Template created successfully',
        UPDATE_MESSAGE: 'Template updated successfully',
        UPDATE_STATUS: {
          TITLE: 'Update Template Status',
          WAIT_DESCRIPTION: 'Updating template status...',
          MESSAGE: 'Template status updated successfully',
        },
      },
      MAPPING: {
        MAPPING_LIST: 'Form-Template Mapping List',
        ADD_MAPPING: 'Add Mapping',
        ID: 'ID',
        FORM: 'Form',
        TEMPLATE: 'Template',
        CATEGORY: 'Category',
        CREATE_TITLE: 'Create Form-Template Mapping',
        UPDATE_TITLE: 'Update Form-Template Mapping',
        RESET_TITLE: 'Reset Form-Template Mapping',
        CREATE_MESSAGE: 'Form-Template Mapping created successfully',
        UPDATE_MESSAGE: 'Form-Template Mapping updated successfully',
        RESET_MESSAGE: 'Form-Template Mapping reset successfully',
      },
      CUSTOM_MAPPING: {
        CUSTOM_MAPPING_LIST: 'Custom Mapping List',
        ADD_CUSTOM_MAPPING: 'Add Custom Mapping',
        NAME: 'Name',
        CREATE_TITLE: 'Create Custom Mapping',
        UPDATE_TITLE: 'Update Custom Mapping',
      },
    },
    DOCS_MODULE: {
      TITLES: {
        DOCUMENTS_MANAGEMENT: 'Documents Management',
        CATEGORIES_SHARING: 'Categories & Sharing Configs',
        DOCUMENTS: 'Documents',
        ACCESS_HISTORY: 'Access History',
      },
      CATEGORY: {
        CATEGORIES_LIST: 'Categories List',
        ADD_CATEGORY: 'Add Category',
        SHARING_CONFIGS: 'Sharing Configs',
        ID: 'ID',
        NAME: 'Name',
        ENTITY_TYPES: 'Entity Types',
        PHI: 'PHI',
        PATIENT_ONLY: 'Patient Only',
        MOBILE_VISIBLE: 'Mobile Visible',
        NOTIFICATION_LEVEL: 'Notification Level',
        ORIGIN: 'Origin',
        CREATE_TITLE: 'Create Category',
        UPDATE_TITLE: 'Update Category',
        VIEW_TITLE: 'View Category',
        CREATE_MESSAGE: 'Category created successfully',
        UPDATE_MESSAGE: 'Category updated successfully',
        UPDATE_SHARING_CONFIGS_MESSAGE: 'Sharing Configs updated successfully',
      },
      DOCUMENT: {
        DOCUMENTS_LIST: 'Documents List',
        ADD_DOCUMENT: 'Add Document',
        SHARE_DOCUMENT: 'Share Document',
        ID: 'ID',
        REFERENCE_ID: 'Reference ID',
        NAME: 'Name',
        DESCRIPTION: 'Description',
        CATEGORY: 'Category',
        TYPE: 'Type',
        URL: 'URL',
        FILE: 'File',
        ENTITY_TYPE: 'Entity Type',
        ENTITIES: 'Entities',
        ENTITY: 'Entity',
        RELATION_CATEGORIES: 'Relation Categories',
        RELATION_TYPES: 'Relation Types',
        PHI: 'PHI',
        PATIENT_ONLY: 'Patient Only',
        MOBILE_VISIBLE: 'Mobile Visible',
        CREATED_DATE: 'Created Date',
        REVIEW: 'Review',
        REVIEWER: 'Reviewer',
        REVIEW_MODE: 'Review Mode',
        CONTACT_REVIEWERS: 'Contact Reviewers',
        REVIEW_BY_DATE: 'Review By Date',
        VISIBLE_AFTER: 'Visible After',
        EXPIRY_AFTER: 'Expiry After',
        REVIEWED: 'Reviewed',
        SELECT_DOCUMENT_SHARE: 'Select Document to Share',
        DOCUMENT: 'Document',
        METHODS: 'Methods',
        TO: 'To',
        CREATE_TITLE: 'Create Document',
        UPDATE_TITLE: 'Update Document',
        VIEW_TITLE: 'View Document',
        CREATE_MESSAGE: 'Document created successfully',
        UPDATE_MESSAGE: 'Document updated successfully',
        SHARE_MESSAGE: 'Document shared successfully',
      },
      ACCESS_HISTORY: {
        ACCESS_HISTORY_LIST: 'Access History List',
        ID: 'ID',
        DOCUMENT: 'Document',
        CATEGORY: 'Category',
        ENTITIES: 'Entities',
        ENTITY: 'Entity',
        ACCESS_TYPE: 'Access Type',
        DOWNLOAD_REASON: 'Download Reason',
        ACCESS_TIME: 'Access Time',
        USER_TYPE: 'User Type',
        ACCESSED_BY: 'Accessed By',
      },
    },
    WORKOS: {
      WORKOS_LIST: 'WorkOS List',
      INPUT: {
        COMPANY_ID: 'Company ID',
        COMPANY: 'Company',
        ORGANIZATION_ID: 'Organization ID',
        CONNECTION_ID: 'Connection ID',
        WORKOS_CLIENT_ID: 'WorkOS Client ID',
        WORKOS_API_KEY: 'WorkOS API Key',
        REDIRECT_URL: 'Redirect URL',
      },
      NEW_WORKOS: 'Create WorkOS',
      EDIT_WORKOS: 'Edit WorkOS',
      ADD_WORKOS: 'Add WorkOS',
      ADD_MESSAGE: 'WorkOS added successfully',
      UPDATE_MESSAGE: 'WorkOS updated successfully',
    },
  },
};
